export const IconBalance = () => {
  return (
    <svg
      className="header-balance__icon"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_239_2201)">
        <path
          d="M3.40484 4.16663C3.8015 3.82913 5.179 3.33329 6.6665 3.33329C8.154 3.33329 9.5315 3.82829 9.92817 4.16663H11.6665C11.6665 2.29663 8.23234 1.66663 6.6665 1.66663C5.10067 1.66663 1.6665 2.29663 1.6665 4.16663V14.1666C1.6665 16.0375 5.10067 16.6666 6.6665 16.6666C6.90567 16.6666 7.19234 16.65 7.49984 16.6183V14.945C7.22341 14.9799 6.94513 14.9983 6.6665 15C5.06984 15 3.59817 14.4291 3.33317 14.095V13.5175C4.43317 13.9808 5.82067 14.1666 6.6665 14.1666C6.9065 14.1666 7.19234 14.15 7.49984 14.1183V12.445C7.22341 12.4799 6.94513 12.4983 6.6665 12.5C5.05234 12.5 3.57567 11.9183 3.33317 11.585V11.0166C4.43317 11.4808 5.82067 11.6666 6.6665 11.6666C6.9065 11.6666 7.19234 11.65 7.49984 11.6183V9.94496C7.22341 9.97992 6.94513 9.99829 6.6665 9.99996C5.05234 9.99996 3.57567 9.41829 3.33317 9.08496V8.51663C4.43317 8.98079 5.82067 9.16663 6.6665 9.16663C6.9065 9.16663 7.19234 9.14996 7.49984 9.11829V7.44579C7.22335 7.48006 6.9451 7.49815 6.6665 7.49996C5.05234 7.49996 3.57567 6.91913 3.33317 6.58579V6.01746C4.43317 6.48079 5.82067 6.66663 6.6665 6.66663C6.9065 6.66663 7.19234 6.64996 7.49984 6.61829V4.94663C7.22333 4.98061 6.94508 4.99842 6.6665 4.99996C5.17984 4.99996 3.8015 4.50579 3.40484 4.16663Z"
          fill="#0B0C0E"
        />
        <path
          d="M13.333 5.83325C11.7672 5.83325 8.33301 6.46325 8.33301 8.33325V15.8333C8.33301 17.7041 11.7672 18.3333 13.333 18.3333C14.8988 18.3333 18.333 17.7041 18.333 15.8333V8.33325C18.333 6.46325 14.8988 5.83325 13.333 5.83325ZM16.6663 10.7524C16.4238 11.0858 14.9472 11.6666 13.333 11.6666C11.7188 11.6666 10.2422 11.0849 9.99967 10.7516V10.1833C11.0997 10.6474 12.4872 10.8333 13.333 10.8333C14.1788 10.8333 15.5663 10.6474 16.6663 10.1841V10.7524ZM16.6663 13.2524C16.4238 13.5858 14.9472 14.1666 13.333 14.1666C11.7188 14.1666 10.2422 13.5849 9.99967 13.2516V12.6833C11.0997 13.1474 12.4872 13.3333 13.333 13.3333C14.1788 13.3333 15.5663 13.1474 16.6663 12.6841V13.2524ZM13.333 7.49992C14.8205 7.49992 16.198 7.99492 16.5947 8.33325C16.198 8.67159 14.8197 9.16659 13.333 9.16659C11.8463 9.16659 10.468 8.67159 10.0713 8.33325C10.468 7.99575 11.8455 7.49992 13.333 7.49992ZM13.333 16.6666C11.7363 16.6666 10.2647 16.0958 9.99967 15.7616V15.1841C11.0997 15.6474 12.4872 15.8333 13.333 15.8333C14.1788 15.8333 15.5663 15.6474 16.6663 15.1841V15.7616C16.4013 16.0958 14.9297 16.6666 13.333 16.6666Z"
          fill="#0B0C0E"
        />
      </g>
      <defs>
        <clipPath id="clip0_239_2201">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconDownload = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 15.8333H17.5V17.5H2.5V15.8333ZM10.8333 10.9763L15.8926 5.91704L17.0711 7.09556L10 14.1666L2.92893 7.09556L4.10744 5.91704L9.16667 10.9763V1.66663H10.8333V10.9763Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconSearch = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4 7.8C2.4 5.0938 4.5938 2.9 7.3 2.9C10.0062 2.9 12.2 5.0938 12.2 7.8C12.2 10.5062 10.0062 12.7 7.3 12.7C4.5938 12.7 2.4 10.5062 2.4 7.8ZM7.3 1.5C3.82061 1.5 1 4.32061 1 7.8C1 11.2794 3.82061 14.1 7.3 14.1C8.78751 14.1 10.1546 13.5845 11.2324 12.7223L13.805 15.295C14.0784 15.5683 14.5216 15.5683 14.795 15.295C15.0683 15.0216 15.0683 14.5784 14.795 14.305L12.2223 11.7324C13.0845 10.6546 13.6 9.28751 13.6 7.8C13.6 4.32061 10.7794 1.5 7.3 1.5Z"
        fill="#71706F"
      />
    </svg>
  )
}

export const IconFilter = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99992 4.49996C9.26354 4.49996 8.66658 5.09691 8.66658 5.83329C8.66658 6.56967 9.26354 7.16663 9.99992 7.16663C10.7363 7.16663 11.3333 6.56967 11.3333 5.83329C11.3333 5.09691 10.7363 4.49996 9.99992 4.49996ZM7.41726 5.16663C7.71329 4.01647 8.75736 3.16663 9.99992 3.16663C11.2425 3.16663 12.2865 4.01647 12.5826 5.16663H13.9999C14.3681 5.16663 14.6666 5.4651 14.6666 5.83329C14.6666 6.20148 14.3681 6.49996 13.9999 6.49996H12.5826C12.2865 7.65011 11.2425 8.49996 9.99992 8.49996C8.75736 8.49996 7.71329 7.65011 7.41726 6.49996H1.99992C1.63173 6.49996 1.33325 6.20148 1.33325 5.83329C1.33325 5.4651 1.63173 5.16663 1.99992 5.16663H7.41726ZM5.99992 9.83329C5.26354 9.83329 4.66658 10.4302 4.66658 11.1666C4.66658 11.903 5.26354 12.5 5.99992 12.5C6.7363 12.5 7.33325 11.903 7.33325 11.1666C7.33325 10.4302 6.7363 9.83329 5.99992 9.83329ZM3.41726 10.5C3.71329 9.34981 4.75736 8.49996 5.99992 8.49996C7.24248 8.49996 8.28654 9.34981 8.58257 10.5H13.9999C14.3681 10.5 14.6666 10.7984 14.6666 11.1666C14.6666 11.5348 14.3681 11.8333 13.9999 11.8333H8.58257C8.28654 12.9834 7.24248 13.8333 5.99992 13.8333C4.75736 13.8333 3.71329 12.9834 3.41726 11.8333H1.99992C1.63173 11.8333 1.33325 11.5348 1.33325 11.1666C1.33325 10.7984 1.63173 10.5 1.99992 10.5H3.41726Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconBtnCreate = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4.25V14.75"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 9.5H14.25"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconWhatsapp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.9886 20.9463L12.88 19.9522L12.35 20.0101L12.1027 20.4825L12.9886 20.9463ZM6.45572 19.09L7.06966 19.8793L8.08109 19.0927L7.07226 18.3027L6.45572 19.09ZM4.23006 20.8211L3.61612 20.0317L3.61611 20.0317L4.23006 20.8211ZM20 12C20 16.1206 16.8838 19.5148 12.88 19.9522L13.0973 21.9404C18.1043 21.3933 22 17.1523 22 12H20ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM4 12C4 7.58172 7.58172 4 12 4V2C6.47715 2 2 6.47715 2 12H4ZM7.07226 18.3027C5.20015 16.8366 4 14.5587 4 12H2C2 15.1996 3.50381 18.0485 5.83917 19.8773L7.07226 18.3027ZM4.844 21.6104L7.06966 19.8793L5.84178 18.3006L3.61612 20.0317L4.844 21.6104ZM4.29145 20C5.1484 20 5.52041 21.0843 4.84401 21.6104L3.61611 20.0317C2.78939 20.6747 3.24408 22 4.29145 22V20ZM12 20H4.29145V22H12V20ZM12.9 20H12V22H12.9V20ZM12.1027 20.4825C12.2517 20.1979 12.5519 20 12.9 20V22C13.3252 22 13.6921 21.7586 13.8746 21.4102L12.1027 20.4825Z"
        fill="#0B0C0E"
      />
      <path
        d="M8.49139 7.38922C8.362 7.39831 8.23514 7.42991 8.11964 7.489C8.03299 7.53333 7.95255 7.5974 7.82616 7.71675C7.70681 7.82944 7.63764 7.92786 7.56476 8.02275C7.19506 8.50409 6.99636 9.09494 7.00005 9.70187C7.00206 10.1925 7.1295 10.6693 7.33076 11.1145C7.73889 12.0173 8.41195 12.9717 9.30101 13.8568C9.51457 14.0694 9.7238 14.2843 9.94941 14.4829C11.0529 15.4545 12.3679 16.1551 13.7898 16.5291C13.7898 16.5291 14.3498 16.6151 14.358 16.6156C14.5435 16.6256 14.7287 16.6122 14.9144 16.6027C15.2057 16.5877 15.4901 16.5089 15.7475 16.3718C15.913 16.2837 15.9913 16.2399 16.1302 16.1523C16.1302 16.1523 16.1728 16.1235 16.255 16.0623C16.39 15.9617 16.4734 15.8909 16.5857 15.7743C16.6685 15.6883 16.7397 15.5867 16.7947 15.4722C16.8729 15.309 16.9516 14.9975 16.9829 14.7388C17.0068 14.5412 16.9996 14.4332 16.997 14.3663C16.9927 14.2587 16.9038 14.148 16.8064 14.101L16.2249 13.8396C16.2249 13.8396 15.3554 13.4612 14.8236 13.2186C14.7682 13.1933 14.7076 13.1816 14.6467 13.1779C14.5133 13.1697 14.3638 13.2045 14.2687 13.3047C14.2637 13.3027 14.1975 13.3599 13.474 14.2364C13.4341 14.2841 13.3406 14.3878 13.1789 14.3781C13.1545 14.3764 13.1302 14.3729 13.1065 14.3667C13.041 14.3494 12.9772 14.3266 12.9148 14.3002C12.7911 14.2477 12.7477 14.2278 12.6632 14.1914C12.0859 13.9392 11.5561 13.6018 11.0878 13.1889C10.9622 13.0783 10.8454 12.9592 10.725 12.8425C10.3048 12.4352 9.96076 12.002 9.70484 11.5747C9.69087 11.5514 9.66934 11.5177 9.64615 11.48C9.60428 11.4119 9.5581 11.3309 9.54362 11.2753C9.50645 11.1282 9.60506 11.01 9.60506 11.01C9.60506 11.01 9.84846 10.7439 9.96155 10.5992C10.0704 10.4599 10.1643 10.3237 10.2241 10.2266C10.3419 10.0372 10.3792 9.84151 10.3173 9.69052C10.0367 9.00654 9.74725 8.32625 9.44893 7.64983C9.39005 7.51634 9.21492 7.41935 9.05566 7.40096C9.00172 7.39473 8.94782 7.38847 8.89366 7.38491C8.7596 7.37837 8.62527 7.37981 8.49139 7.38922Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconEnvelope = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.21917 10.3753C6.56418 9.94404 7.19347 9.87412 7.62473 10.2191L12 13.7194L16.3753 10.2191C16.8066 9.87412 17.4359 9.94404 17.7809 10.3753C18.1259 10.8066 18.056 11.4359 17.6247 11.7809L13.2494 15.2811C12.519 15.8655 11.4811 15.8655 10.7506 15.2811L6.37534 11.7809C5.94408 11.4359 5.87416 10.8066 6.21917 10.3753Z"
        fill="#0B0C0E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.926 3.41714C12.7266 2.75817 11.2734 2.75817 10.074 3.41714L4.07399 6.71343C2.79486 7.41616 2 8.75977 2 10.2192V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17V10.2192C22 8.75976 21.2051 7.41616 19.926 6.71343L13.926 3.41714ZM11.037 5.17002C11.6367 4.84054 12.3633 4.84054 12.963 5.17002L18.963 8.46632C19.6026 8.81768 20 9.48949 20 10.2192V17C20 18.1046 19.1046 19 18 19H6C4.89543 19 4 18.1046 4 17V10.2192C4 9.48949 4.39743 8.81768 5.03699 8.46632L11.037 5.17002Z"
        fill="#0B0C0E"
      />
      <path
        d="M6.21917 10.3753C6.56418 9.94404 7.19347 9.87412 7.62473 10.2191L12 13.7194L16.3753 10.2191C16.8066 9.87412 17.4359 9.94404 17.7809 10.3753C18.1259 10.8066 18.056 11.4359 17.6247 11.7809L13.2494 15.2811C12.519 15.8655 11.4811 15.8655 10.7506 15.2811L6.37534 11.7809C5.94408 11.4359 5.87416 10.8066 6.21917 10.3753Z"
        stroke="#0B0C0E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.926 3.41714C12.7266 2.75817 11.2734 2.75817 10.074 3.41714L4.07399 6.71343C2.79486 7.41616 2 8.75977 2 10.2192V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17V10.2192C22 8.75976 21.2051 7.41616 19.926 6.71343L13.926 3.41714ZM11.037 5.17002C11.6367 4.84054 12.3633 4.84054 12.963 5.17002L18.963 8.46632C19.6026 8.81768 20 9.48949 20 10.2192V17C20 18.1046 19.1046 19 18 19H6C4.89543 19 4 18.1046 4 17V10.2192C4 9.48949 4.39743 8.81768 5.03699 8.46632L11.037 5.17002Z"
        stroke="#0B0C0E"
      />
    </svg>
  )
}

export const IconCopyDoc = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.4 22.75H7.6C3.21 22.75 1.25 20.79 1.25 16.4V12.6C1.25 8.21 3.21 6.25 7.6 6.25H10.6C11.01 6.25 11.35 6.59 11.35 7C11.35 7.41 11.01 7.75 10.6 7.75H7.6C4.02 7.75 2.75 9.02 2.75 12.6V16.4C2.75 19.98 4.02 21.25 7.6 21.25H11.4C14.98 21.25 16.25 19.98 16.25 16.4V13.4C16.25 12.99 16.59 12.65 17 12.65C17.41 12.65 17.75 12.99 17.75 13.4V16.4C17.75 20.79 15.79 22.75 11.4 22.75Z"
        fill="#0B0C0E"
      />
      <path
        d="M17 14.1501H13.8C10.99 14.1501 9.84998 13.0101 9.84998 10.2001V7.00011C9.84998 6.70011 10.03 6.42011 10.31 6.31011C10.59 6.19011 10.91 6.26011 11.13 6.47011L17.53 12.8701C17.74 13.0801 17.81 13.4101 17.69 13.6901C17.58 13.9701 17.3 14.1501 17 14.1501ZM11.35 8.81011V10.2001C11.35 12.1901 11.81 12.6501 13.8 12.6501H15.19L11.35 8.81011Z"
        fill="#0B0C0E"
      />
      <path
        d="M15.6 2.75H11.6C11.19 2.75 10.85 2.41 10.85 2C10.85 1.59 11.19 1.25 11.6 1.25H15.6C16.01 1.25 16.35 1.59 16.35 2C16.35 2.41 16.01 2.75 15.6 2.75Z"
        fill="#0B0C0E"
      />
      <path
        d="M7 5.75C6.59 5.75 6.25 5.41 6.25 5C6.25 2.93 7.93 1.25 10 1.25H12.62C13.03 1.25 13.37 1.59 13.37 2C13.37 2.41 13.03 2.75 12.62 2.75H10C8.76 2.75 7.75 3.76 7.75 5C7.75 5.41 7.41 5.75 7 5.75Z"
        fill="#0B0C0E"
      />
      <path
        d="M19.1898 17.75C18.7798 17.75 18.4398 17.41 18.4398 17C18.4398 16.59 18.7798 16.25 19.1898 16.25C20.3298 16.25 21.2498 15.32 21.2498 14.19V8C21.2498 7.59 21.5898 7.25 21.9998 7.25C22.4098 7.25 22.7498 7.59 22.7498 8V14.19C22.7498 16.15 21.1498 17.75 19.1898 17.75Z"
        fill="#0B0C0E"
      />
      <path
        d="M22 8.75008H19C16.34 8.75008 15.25 7.66008 15.25 5.00008V2.00008C15.25 1.70008 15.43 1.42008 15.71 1.31008C15.99 1.19008 16.31 1.26008 16.53 1.47008L22.53 7.47008C22.74 7.68008 22.81 8.01008 22.69 8.29008C22.58 8.57008 22.3 8.75008 22 8.75008ZM16.75 3.81008V5.00008C16.75 6.83008 17.17 7.25008 19 7.25008H20.19L16.75 3.81008Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconAletInfo = () => {
  return (
    <svg
      className="after-reset__icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.0001C17.5228 22.0001 22 17.5229 22 12.0001C22 6.47721 17.5228 2.00006 12 2.00006C6.47715 2.00006 2 6.47721 2 12.0001C2 17.5229 6.47715 22.0001 12 22.0001Z"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.00006V12.0001"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.0001H12.01"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// event

export const IconEventNumber1 = () => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.97337 8.70724C8.0322 8.70724 8.94895 8.32748 9.69821 7.57822C10.4472 6.82907 10.8271 5.91245 10.8271 4.8535C10.8271 3.79491 10.4474 2.87817 9.69809 2.12878C8.94883 1.37976 8.03208 1 6.97337 1C5.91442 1 4.99779 1.37976 4.24865 2.1289C3.49951 2.87804 3.11963 3.79479 3.11963 4.8535C3.11963 5.91245 3.49951 6.8292 4.24865 7.57834C4.99804 8.32736 5.91478 8.70724 6.97337 8.70724ZM4.91173 2.79186C5.48656 2.21704 6.16087 1.93762 6.97337 1.93762C7.78575 1.93762 8.46018 2.21704 9.03513 2.79186C9.60996 3.36681 9.8895 4.04125 9.8895 4.8535C9.8895 5.66599 9.60996 6.34031 9.03513 6.91526C8.46018 7.4902 7.78575 7.76962 6.97337 7.76962C6.16112 7.76962 5.48681 7.49008 4.91173 6.91526C4.33679 6.34043 4.05725 5.66599 4.05725 4.8535C4.05725 4.04125 4.33679 3.36681 4.91173 2.79186Z"
        fill="#B7B7B7"
        stroke="#B7B7B7"
        strokeWidth="0.280723"
      />
      <path
        d="M13.7164 13.3032C13.6948 12.9914 13.6511 12.6513 13.5867 12.2922C13.5218 11.9304 13.4382 11.5884 13.3381 11.2757C13.2346 10.9526 13.0941 10.6335 12.9201 10.3278C12.7398 10.0104 12.5279 9.734 12.2901 9.50659C12.0415 9.26867 11.737 9.07739 11.385 8.93787C11.0341 8.79907 10.6453 8.72876 10.2294 8.72876C10.0661 8.72876 9.90816 8.79578 9.60311 8.99438C9.41536 9.11682 9.19576 9.25842 8.95064 9.41504C8.74105 9.54858 8.45712 9.6737 8.10641 9.78698C7.76425 9.8977 7.41684 9.95385 7.07382 9.95385C6.73105 9.95385 6.38364 9.8977 6.04123 9.78698C5.69089 9.67382 5.40684 9.5487 5.19761 9.41516C4.95481 9.26001 4.73509 9.11841 4.54454 8.99426C4.23973 8.79565 4.08177 8.72864 3.91844 8.72864C3.50243 8.72864 3.11376 8.79907 2.76305 8.93799C2.41125 9.07727 2.10668 9.26855 1.85778 9.50671C1.61999 9.73425 1.40808 10.0105 1.2279 10.3278C1.0542 10.6335 0.913572 10.9525 0.810057 11.2759C0.710082 11.5885 0.626464 11.9304 0.561523 12.2922C0.49707 12.6509 0.453491 12.9911 0.431885 13.3036C0.410644 13.6091 0.399902 13.9271 0.399902 14.2484C0.399902 15.0836 0.665404 15.7597 1.18896 16.2584C1.70605 16.7505 2.39013 17 3.22228 17H10.9263C11.7582 17 12.4423 16.7505 12.9595 16.2584C13.4832 15.7601 13.7487 15.0837 13.7487 14.2483C13.7486 13.9259 13.7377 13.6079 13.7164 13.3032ZM12.3131 15.5791C11.9714 15.9043 11.5178 16.0623 10.9262 16.0623H3.22228C2.63061 16.0623 2.17699 15.9043 1.83544 15.5792C1.50036 15.2602 1.33752 14.8248 1.33752 14.2484C1.33752 13.9486 1.34741 13.6526 1.36718 13.3684C1.38647 13.0896 1.4259 12.7833 1.48437 12.4579C1.54211 12.1365 1.6156 11.8348 1.703 11.5618C1.78686 11.2999 1.90124 11.0406 2.04308 10.7909C2.17846 10.5528 2.33422 10.3486 2.50609 10.1841C2.66686 10.0301 2.8695 9.90417 3.10826 9.80969C3.32909 9.72229 3.57726 9.67443 3.84666 9.66723C3.8795 9.68469 3.93797 9.71801 4.0327 9.77978C4.22545 9.90539 4.44761 10.0487 4.69322 10.2056C4.97007 10.3821 5.32676 10.5415 5.75291 10.6791C6.18857 10.8199 6.63291 10.8915 7.07394 10.8915C7.51498 10.8915 7.95944 10.8199 8.39486 10.6792C8.82137 10.5414 9.17794 10.3821 9.45516 10.2053C9.7065 10.0447 9.92244 9.90551 10.1152 9.77978C10.2099 9.71814 10.2684 9.68469 10.3012 9.66723C10.5708 9.67443 10.8189 9.72229 11.0399 9.80969C11.2785 9.90417 11.4812 10.0303 11.6419 10.1841C11.8138 10.3485 11.9696 10.5527 12.1049 10.791C12.2469 11.0406 12.3614 11.3 12.4451 11.5616C12.5327 11.8351 12.6063 12.1366 12.6639 12.4577C12.7222 12.7838 12.7618 13.0902 12.7811 13.3685V13.3688C12.801 13.6518 12.811 13.9477 12.8111 14.2484C12.811 14.8249 12.6481 15.2602 12.3131 15.5791Z"
        fill="#B7B7B7"
        stroke="#B7B7B7"
        strokeWidth="0.280723"
      />
    </svg>
  )
}

export const IconEventNumber2 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_3505_2786" fill="white">
        <path d="M7.3135 14.7228H1.87669C1.67469 14.7228 1.49062 14.6294 1.3716 14.4664C1.25256 14.3033 1.21978 14.0996 1.28164 13.9075C1.89932 11.9905 3.78304 10.6516 5.86248 10.6516C6.83004 10.6516 7.7592 10.9424 8.54952 11.4927C8.8326 11.6898 9.22208 11.6205 9.4196 11.3379C9.617 11.0553 9.5476 10.6665 9.26452 10.4693C8.87329 10.1969 8.45532 9.97473 8.01811 9.80507C8.59982 9.27707 8.98573 8.53773 9.05279 7.70982C9.93483 6.85208 11.091 6.38208 12.3304 6.38208C13.298 6.38208 14.2271 6.67295 15.0174 7.2232C15.3005 7.42029 15.69 7.35101 15.8875 7.06842C16.0849 6.78583 16.0155 6.39698 15.7324 6.19986C15.3412 5.92745 14.9232 5.70524 14.486 5.53558C15.1277 4.95314 15.5311 4.11352 15.5311 3.18159C15.5312 1.42728 14.1014 0 12.3441 0C10.5867 0 9.157 1.42728 9.157 3.18165C9.157 4.1098 9.55718 4.94643 10.1944 5.52858C10.1072 5.56208 10.0206 5.59771 9.9347 5.63546C9.54366 5.80724 9.17587 6.01811 8.834 6.26617C8.36232 5.09696 7.21417 4.26952 5.87613 4.26952C4.11874 4.26952 2.68905 5.6968 2.68905 7.45117C2.68905 8.3766 3.08692 9.21104 3.72081 9.79298C2.02579 10.4271 0.651402 11.7889 0.0918816 13.5256C-0.0936861 14.1016 0.00460719 14.7123 0.361593 15.2013C0.718517 15.6902 1.27071 15.9706 1.87672 15.9706H7.31353C7.65868 15.9706 7.93844 15.6913 7.93844 15.3468C7.93844 15.0022 7.65862 14.7228 7.3135 14.7228ZM12.3441 1.24768C13.4123 1.24768 14.2814 2.11524 14.2814 3.18162C14.2814 4.24799 13.4123 5.11555 12.3441 5.11555C11.2759 5.11555 10.4069 4.24799 10.4069 3.18162C10.4069 2.11524 11.2759 1.24768 12.3441 1.24768ZM5.87616 5.51717C6.94436 5.51717 7.81341 6.38473 7.81341 7.45111C7.81341 8.51748 6.94436 9.38504 5.87616 9.38504C4.80796 9.38504 3.93891 8.51748 3.93891 7.45111C3.93891 6.38473 4.80796 5.51717 5.87616 5.51717Z" />
      </mask>
      <path
        d="M7.3135 14.7228H1.87669C1.67469 14.7228 1.49062 14.6294 1.3716 14.4664C1.25256 14.3033 1.21978 14.0996 1.28164 13.9075C1.89932 11.9905 3.78304 10.6516 5.86248 10.6516C6.83004 10.6516 7.7592 10.9424 8.54952 11.4927C8.8326 11.6898 9.22208 11.6205 9.4196 11.3379C9.617 11.0553 9.5476 10.6665 9.26452 10.4693C8.87329 10.1969 8.45532 9.97473 8.01811 9.80507C8.59982 9.27707 8.98573 8.53773 9.05279 7.70982C9.93483 6.85208 11.091 6.38208 12.3304 6.38208C13.298 6.38208 14.2271 6.67295 15.0174 7.2232C15.3005 7.42029 15.69 7.35101 15.8875 7.06842C16.0849 6.78583 16.0155 6.39698 15.7324 6.19986C15.3412 5.92745 14.9232 5.70524 14.486 5.53558C15.1277 4.95314 15.5311 4.11352 15.5311 3.18159C15.5312 1.42728 14.1014 0 12.3441 0C10.5867 0 9.157 1.42728 9.157 3.18165C9.157 4.1098 9.55718 4.94643 10.1944 5.52858C10.1072 5.56208 10.0206 5.59771 9.9347 5.63546C9.54366 5.80724 9.17587 6.01811 8.834 6.26617C8.36232 5.09696 7.21417 4.26952 5.87613 4.26952C4.11874 4.26952 2.68905 5.6968 2.68905 7.45117C2.68905 8.3766 3.08692 9.21104 3.72081 9.79298C2.02579 10.4271 0.651402 11.7889 0.0918816 13.5256C-0.0936861 14.1016 0.00460719 14.7123 0.361593 15.2013C0.718517 15.6902 1.27071 15.9706 1.87672 15.9706H7.31353C7.65868 15.9706 7.93844 15.6913 7.93844 15.3468C7.93844 15.0022 7.65862 14.7228 7.3135 14.7228ZM12.3441 1.24768C13.4123 1.24768 14.2814 2.11524 14.2814 3.18162C14.2814 4.24799 13.4123 5.11555 12.3441 5.11555C11.2759 5.11555 10.4069 4.24799 10.4069 3.18162C10.4069 2.11524 11.2759 1.24768 12.3441 1.24768ZM5.87616 5.51717C6.94436 5.51717 7.81341 6.38473 7.81341 7.45111C7.81341 8.51748 6.94436 9.38504 5.87616 9.38504C4.80796 9.38504 3.93891 8.51748 3.93891 7.45111C3.93891 6.38473 4.80796 5.51717 5.87616 5.51717Z"
        fill="#B7B7B7"
      />
      <path
        d="M1.3716 14.4664L0.237964 15.294L0.238011 15.2941L1.3716 14.4664ZM1.28164 13.9075L-0.0543414 13.4771L-0.0544169 13.4773L1.28164 13.9075ZM8.54952 11.4927L9.35154 10.3408L9.35152 10.3408L8.54952 11.4927ZM9.4196 11.3379L10.57 12.142L10.5703 12.1417L9.4196 11.3379ZM9.26452 10.4693L10.0666 9.3175L10.0666 9.31745L9.26452 10.4693ZM8.01811 9.80507L7.07475 8.76574L5.39314 10.2921L7.51034 11.1136L8.01811 9.80507ZM9.05279 7.70982L8.07423 6.70356L7.69631 7.07108L7.65375 7.59652L9.05279 7.70982ZM15.0174 7.2232L15.8195 6.07129L15.8194 6.07128L15.0174 7.2232ZM15.8875 7.06842L17.038 7.87246L17.0382 7.87221L15.8875 7.06842ZM15.7324 6.19986L16.5345 5.04801L16.5345 5.04796L15.7324 6.19986ZM14.486 5.53558L13.5427 4.49625L11.8611 6.02258L13.9783 6.84413L14.486 5.53558ZM15.5311 3.18159L14.1275 3.18156V3.18159H15.5311ZM10.1944 5.52858L10.6978 6.83879L12.8178 6.02419L11.1411 4.49234L10.1944 5.52858ZM9.9347 5.63546L10.4992 6.92054L10.4993 6.92053L9.9347 5.63546ZM8.834 6.26617L7.53232 6.79129L8.20439 8.45722L9.65834 7.40222L8.834 6.26617ZM3.72081 9.79298L4.21263 11.1076L6.35522 10.306L4.67003 8.759L3.72081 9.79298ZM0.0918816 13.5256L1.42787 13.956L1.42787 13.956L0.0918816 13.5256ZM0.361593 15.2013L1.49525 14.3737L1.49523 14.3737L0.361593 15.2013ZM7.3135 13.3192H1.87669V16.1265H7.3135V13.3192ZM1.87669 13.3192C2.12239 13.3192 2.3597 13.4394 2.5052 13.6387L0.238011 15.2941C0.621542 15.8193 1.22698 16.1265 1.87669 16.1265V13.3192ZM2.50524 13.6387C2.65098 13.8383 2.69353 14.1022 2.61769 14.3378L-0.0544169 13.4773C-0.253969 14.097 -0.145864 14.7683 0.237964 15.294L2.50524 13.6387ZM2.61762 14.338C3.04023 13.0263 4.36527 12.0552 5.86248 12.0552V9.24795C3.20082 9.24795 0.758406 10.9546 -0.0543413 13.4771L2.61762 14.338ZM5.86248 12.0552C6.54469 12.0552 7.1937 12.259 7.74751 12.6446L9.35152 10.3408C8.32469 9.62586 7.11539 9.24795 5.86248 9.24795V12.0552ZM7.7475 12.6446C8.66544 13.2837 9.92863 13.0597 10.57 12.142L8.26916 10.5338C8.51552 10.1813 8.99975 10.0959 9.35154 10.3408L7.7475 12.6446ZM10.5703 12.1417C11.2125 11.2223 10.9859 9.95765 10.0666 9.3175L8.46242 11.6212C8.10929 11.3753 8.02153 10.8883 8.26892 10.5341L10.5703 12.1417ZM10.0666 9.31745C9.58415 8.98156 9.06745 8.70667 8.52587 8.49652L7.51034 11.1136C7.8432 11.2428 8.16243 11.4123 8.46248 11.6212L10.0666 9.31745ZM8.96147 10.8444C9.7962 10.0867 10.3548 9.02086 10.4518 7.82313L7.65375 7.59652C7.61665 8.0546 7.40344 8.4674 7.07475 8.76574L8.96147 10.8444ZM10.0313 8.71609C10.6506 8.11385 11.4554 7.78569 12.3304 7.78569V4.97846C10.7265 4.97846 9.21902 5.5903 8.07423 6.70356L10.0313 8.71609ZM12.3304 7.78569C13.0126 7.78569 13.6616 7.98954 14.2154 8.37512L15.8194 6.07128C14.7926 5.35637 13.5833 4.97846 12.3304 4.97846V7.78569ZM14.2154 8.37511C15.1333 9.01419 16.3966 8.79026 17.038 7.87246L14.737 6.26438C14.9834 5.91177 15.4677 5.8264 15.8195 6.07129L14.2154 8.37511ZM17.0382 7.87221C17.6804 6.95286 17.4538 5.68816 16.5345 5.04801L14.9303 7.35171C14.5772 7.10581 14.4894 6.6188 14.7368 6.26463L17.0382 7.87221ZM16.5345 5.04796C16.0521 4.71207 15.5354 4.43718 14.9938 4.22703L13.9783 6.84413C14.3111 6.97329 14.6303 7.14283 14.9304 7.35176L16.5345 5.04796ZM15.4294 6.57491C16.3505 5.73884 16.9347 4.52746 16.9347 3.18159H14.1275C14.1275 3.69958 13.9049 4.16745 13.5427 4.49625L15.4294 6.57491ZM16.9347 3.18161C16.9348 0.649805 14.8743 -1.40361 12.3441 -1.40361V1.40361C13.3285 1.40361 14.1275 2.20475 14.1275 3.18156L16.9347 3.18161ZM12.3441 -1.40361C9.81375 -1.40361 7.75338 0.649832 7.75338 3.18165H10.5606C10.5606 2.20472 11.3596 1.40361 12.3441 1.40361V-1.40361ZM7.75338 3.18165C7.75338 4.52207 8.33294 5.72914 9.24762 6.56482L11.1411 4.49234C10.7814 4.16371 10.5606 3.69754 10.5606 3.18165H7.75338ZM9.6909 4.21837C9.58306 4.25981 9.47614 4.30382 9.37015 4.35038L10.4993 6.92053C10.5651 6.89159 10.6313 6.86435 10.6978 6.83879L9.6909 4.21837ZM9.37018 4.35037C8.88816 4.56212 8.43319 4.82281 8.00967 5.13012L9.65834 7.40222C9.91855 7.21341 10.1992 7.05236 10.4992 6.92054L9.37018 4.35037ZM10.1357 5.74105C9.45733 4.05954 7.80637 2.86591 5.87613 2.86591V5.67313C6.62197 5.67313 7.26731 6.13438 7.53232 6.79129L10.1357 5.74105ZM5.87613 2.86591C3.3458 2.86591 1.28543 4.91935 1.28543 7.45117H4.09266C4.09266 6.47425 4.89169 5.67313 5.87613 5.67313V2.86591ZM1.28543 7.45117C1.28543 8.78766 1.86164 9.9916 2.77159 10.827L4.67003 8.759C4.31219 8.43048 4.09266 7.96555 4.09266 7.45117H1.28543ZM3.229 8.47835C1.16019 9.25231 -0.544186 10.9227 -1.24411 13.0952L1.42787 13.956C1.84699 12.6551 2.89138 11.6019 4.21263 11.1076L3.229 8.47835ZM-1.2441 13.0952C-1.5675 14.0989 -1.39379 15.1773 -0.772043 16.029L1.49523 14.3737C1.403 14.2473 1.38013 14.1042 1.42787 13.956L-1.2441 13.0952ZM-0.772062 16.0289C-0.150569 16.8802 0.823071 17.3742 1.87672 17.3742V14.567C1.71835 14.567 1.5876 14.5002 1.49525 14.3737L-0.772062 16.0289ZM1.87672 17.3742H7.31353V14.567H1.87672V17.3742ZM7.31353 17.3742C8.43165 17.3742 9.34205 16.4687 9.34205 15.3468H6.53483C6.53483 14.9139 6.88571 14.567 7.31353 14.567V17.3742ZM9.34205 15.3468C9.34205 14.225 8.43172 13.3192 7.3135 13.3192V16.1265C6.88551 16.1265 6.53483 15.7795 6.53483 15.3468H9.34205ZM12.3441 2.6513C12.6394 2.6513 12.8777 2.89271 12.8777 3.18162H15.685C15.685 1.33778 14.1852 -0.155929 12.3441 -0.155929V2.6513ZM12.8777 3.18162C12.8777 3.47052 12.6394 3.71194 12.3441 3.71194V6.51916C14.1852 6.51916 15.685 5.02545 15.685 3.18162H12.8777ZM12.3441 3.71194C12.0488 3.71194 11.8105 3.47053 11.8105 3.18162H9.00324C9.00324 5.02545 10.503 6.51916 12.3441 6.51916V3.71194ZM11.8105 3.18162C11.8105 2.89271 12.0488 2.6513 12.3441 2.6513V-0.155929C10.503 -0.155929 9.00324 1.33778 9.00324 3.18162H11.8105ZM5.87616 6.92079C6.17144 6.92079 6.4098 7.1622 6.4098 7.45111H9.21703C9.21703 5.60727 7.71729 4.11356 5.87616 4.11356V6.92079ZM6.4098 7.45111C6.4098 7.74001 6.17144 7.98143 5.87616 7.98143V10.7887C7.71729 10.7887 9.21703 9.29494 9.21703 7.45111H6.4098ZM5.87616 7.98143C5.58088 7.98143 5.34252 7.74001 5.34252 7.45111H2.53529C2.53529 9.29494 4.03503 10.7887 5.87616 10.7887V7.98143ZM5.34252 7.45111C5.34252 7.1622 5.58088 6.92079 5.87616 6.92079V4.11356C4.03503 4.11356 2.53529 5.60727 2.53529 7.45111H5.34252Z"
        fill="#B7B7B7"
        mask="url(#path-1-inside-1_3505_2786)"
      />
      <path
        d="M15.7314 10.1181C15.4427 9.91504 15.0413 9.98034 14.8347 10.264L11.667 14.6124C11.5805 14.711 11.472 14.7323 11.414 14.7361C11.3542 14.7401 11.2381 14.7325 11.1385 14.6394L9.08778 12.7042C8.83173 12.4625 8.42484 12.4707 8.17912 12.7223C7.93327 12.9739 7.94154 13.3737 8.19753 13.6153L10.2504 15.5524C10.5578 15.84 10.9682 16 11.3904 16C11.4267 16 11.4631 15.9988 11.4995 15.9964C11.9594 15.9663 12.3889 15.7465 12.6777 15.3934C12.6852 15.3842 12.6923 15.3749 12.6993 15.3654L15.8799 10.9993C16.0864 10.7156 16.02 10.3211 15.7314 10.1181Z"
        fill="#46BA65"
      />
    </svg>
  )
}

export const IconEventNumber3 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_3505_2806" fill="white">
        <path d="M7.3135 14.7228H1.87669C1.67469 14.7228 1.49062 14.6294 1.3716 14.4664C1.25256 14.3033 1.21978 14.0996 1.28164 13.9075C1.89932 11.9905 3.78304 10.6516 5.86248 10.6516C6.83004 10.6516 7.7592 10.9424 8.54952 11.4927C8.8326 11.6898 9.22208 11.6205 9.4196 11.3379C9.617 11.0553 9.5476 10.6665 9.26452 10.4693C8.87329 10.1969 8.45532 9.97473 8.01811 9.80507C8.59982 9.27707 8.98573 8.53773 9.05279 7.70982C9.93483 6.85208 11.091 6.38208 12.3304 6.38208C13.298 6.38208 14.2271 6.67295 15.0174 7.2232C15.3005 7.42029 15.69 7.35101 15.8875 7.06842C16.0849 6.78583 16.0155 6.39698 15.7324 6.19986C15.3412 5.92745 14.9232 5.70524 14.486 5.53558C15.1277 4.95314 15.5311 4.11352 15.5311 3.18159C15.5312 1.42728 14.1014 0 12.3441 0C10.5867 0 9.157 1.42728 9.157 3.18165C9.157 4.1098 9.55718 4.94643 10.1944 5.52858C10.1072 5.56208 10.0206 5.59771 9.9347 5.63546C9.54366 5.80724 9.17587 6.01811 8.834 6.26617C8.36232 5.09696 7.21417 4.26952 5.87613 4.26952C4.11874 4.26952 2.68905 5.6968 2.68905 7.45117C2.68905 8.3766 3.08692 9.21104 3.72081 9.79298C2.02579 10.4271 0.651402 11.7889 0.0918816 13.5256C-0.0936861 14.1016 0.00460719 14.7123 0.361593 15.2013C0.718517 15.6902 1.27071 15.9706 1.87672 15.9706H7.31353C7.65868 15.9706 7.93844 15.6913 7.93844 15.3468C7.93844 15.0022 7.65862 14.7228 7.3135 14.7228ZM12.3441 1.24768C13.4123 1.24768 14.2814 2.11524 14.2814 3.18162C14.2814 4.24799 13.4123 5.11555 12.3441 5.11555C11.2759 5.11555 10.4069 4.24799 10.4069 3.18162C10.4069 2.11524 11.2759 1.24768 12.3441 1.24768ZM5.87616 5.51717C6.94436 5.51717 7.81341 6.38473 7.81341 7.45111C7.81341 8.51748 6.94436 9.38504 5.87616 9.38504C4.80796 9.38504 3.93891 8.51748 3.93891 7.45111C3.93891 6.38473 4.80796 5.51717 5.87616 5.51717Z" />
      </mask>
      <path
        d="M7.3135 14.7228H1.87669C1.67469 14.7228 1.49062 14.6294 1.3716 14.4664C1.25256 14.3033 1.21978 14.0996 1.28164 13.9075C1.89932 11.9905 3.78304 10.6516 5.86248 10.6516C6.83004 10.6516 7.7592 10.9424 8.54952 11.4927C8.8326 11.6898 9.22208 11.6205 9.4196 11.3379C9.617 11.0553 9.5476 10.6665 9.26452 10.4693C8.87329 10.1969 8.45532 9.97473 8.01811 9.80507C8.59982 9.27707 8.98573 8.53773 9.05279 7.70982C9.93483 6.85208 11.091 6.38208 12.3304 6.38208C13.298 6.38208 14.2271 6.67295 15.0174 7.2232C15.3005 7.42029 15.69 7.35101 15.8875 7.06842C16.0849 6.78583 16.0155 6.39698 15.7324 6.19986C15.3412 5.92745 14.9232 5.70524 14.486 5.53558C15.1277 4.95314 15.5311 4.11352 15.5311 3.18159C15.5312 1.42728 14.1014 0 12.3441 0C10.5867 0 9.157 1.42728 9.157 3.18165C9.157 4.1098 9.55718 4.94643 10.1944 5.52858C10.1072 5.56208 10.0206 5.59771 9.9347 5.63546C9.54366 5.80724 9.17587 6.01811 8.834 6.26617C8.36232 5.09696 7.21417 4.26952 5.87613 4.26952C4.11874 4.26952 2.68905 5.6968 2.68905 7.45117C2.68905 8.3766 3.08692 9.21104 3.72081 9.79298C2.02579 10.4271 0.651402 11.7889 0.0918816 13.5256C-0.0936861 14.1016 0.00460719 14.7123 0.361593 15.2013C0.718517 15.6902 1.27071 15.9706 1.87672 15.9706H7.31353C7.65868 15.9706 7.93844 15.6913 7.93844 15.3468C7.93844 15.0022 7.65862 14.7228 7.3135 14.7228ZM12.3441 1.24768C13.4123 1.24768 14.2814 2.11524 14.2814 3.18162C14.2814 4.24799 13.4123 5.11555 12.3441 5.11555C11.2759 5.11555 10.4069 4.24799 10.4069 3.18162C10.4069 2.11524 11.2759 1.24768 12.3441 1.24768ZM5.87616 5.51717C6.94436 5.51717 7.81341 6.38473 7.81341 7.45111C7.81341 8.51748 6.94436 9.38504 5.87616 9.38504C4.80796 9.38504 3.93891 8.51748 3.93891 7.45111C3.93891 6.38473 4.80796 5.51717 5.87616 5.51717Z"
        fill="#B7B7B7"
      />
      <path
        d="M1.3716 14.4664L0.237964 15.294L0.238011 15.2941L1.3716 14.4664ZM1.28164 13.9075L-0.0543414 13.4771L-0.0544169 13.4773L1.28164 13.9075ZM8.54952 11.4927L9.35154 10.3408L9.35152 10.3408L8.54952 11.4927ZM9.4196 11.3379L10.57 12.142L10.5703 12.1417L9.4196 11.3379ZM9.26452 10.4693L10.0666 9.3175L10.0666 9.31745L9.26452 10.4693ZM8.01811 9.80507L7.07475 8.76574L5.39314 10.2921L7.51034 11.1136L8.01811 9.80507ZM9.05279 7.70982L8.07423 6.70356L7.69631 7.07108L7.65375 7.59652L9.05279 7.70982ZM15.0174 7.2232L15.8195 6.07129L15.8194 6.07128L15.0174 7.2232ZM15.8875 7.06842L17.038 7.87246L17.0382 7.87221L15.8875 7.06842ZM15.7324 6.19986L16.5345 5.04801L16.5345 5.04796L15.7324 6.19986ZM14.486 5.53558L13.5427 4.49625L11.8611 6.02258L13.9783 6.84413L14.486 5.53558ZM15.5311 3.18159L14.1275 3.18156V3.18159H15.5311ZM10.1944 5.52858L10.6978 6.83879L12.8178 6.02419L11.1411 4.49234L10.1944 5.52858ZM9.9347 5.63546L10.4992 6.92054L10.4993 6.92053L9.9347 5.63546ZM8.834 6.26617L7.53232 6.79129L8.20439 8.45722L9.65834 7.40222L8.834 6.26617ZM3.72081 9.79298L4.21263 11.1076L6.35522 10.306L4.67003 8.759L3.72081 9.79298ZM0.0918816 13.5256L1.42787 13.956L1.42787 13.956L0.0918816 13.5256ZM0.361593 15.2013L1.49525 14.3737L1.49523 14.3737L0.361593 15.2013ZM7.3135 13.3192H1.87669V16.1265H7.3135V13.3192ZM1.87669 13.3192C2.12239 13.3192 2.3597 13.4394 2.5052 13.6387L0.238011 15.2941C0.621542 15.8193 1.22698 16.1265 1.87669 16.1265V13.3192ZM2.50524 13.6387C2.65098 13.8383 2.69353 14.1022 2.61769 14.3378L-0.0544169 13.4773C-0.253969 14.097 -0.145864 14.7683 0.237964 15.294L2.50524 13.6387ZM2.61762 14.338C3.04023 13.0263 4.36527 12.0552 5.86248 12.0552V9.24795C3.20082 9.24795 0.758406 10.9546 -0.0543413 13.4771L2.61762 14.338ZM5.86248 12.0552C6.54469 12.0552 7.1937 12.259 7.74751 12.6446L9.35152 10.3408C8.32469 9.62586 7.11539 9.24795 5.86248 9.24795V12.0552ZM7.7475 12.6446C8.66544 13.2837 9.92863 13.0597 10.57 12.142L8.26916 10.5338C8.51552 10.1813 8.99975 10.0959 9.35154 10.3408L7.7475 12.6446ZM10.5703 12.1417C11.2125 11.2223 10.9859 9.95765 10.0666 9.3175L8.46242 11.6212C8.10929 11.3753 8.02153 10.8883 8.26892 10.5341L10.5703 12.1417ZM10.0666 9.31745C9.58415 8.98156 9.06745 8.70667 8.52587 8.49652L7.51034 11.1136C7.8432 11.2428 8.16243 11.4123 8.46248 11.6212L10.0666 9.31745ZM8.96147 10.8444C9.7962 10.0867 10.3548 9.02086 10.4518 7.82313L7.65375 7.59652C7.61665 8.0546 7.40344 8.4674 7.07475 8.76574L8.96147 10.8444ZM10.0313 8.71609C10.6506 8.11385 11.4554 7.78569 12.3304 7.78569V4.97846C10.7265 4.97846 9.21902 5.5903 8.07423 6.70356L10.0313 8.71609ZM12.3304 7.78569C13.0126 7.78569 13.6616 7.98954 14.2154 8.37512L15.8194 6.07128C14.7926 5.35637 13.5833 4.97846 12.3304 4.97846V7.78569ZM14.2154 8.37511C15.1333 9.01419 16.3966 8.79026 17.038 7.87246L14.737 6.26438C14.9834 5.91177 15.4677 5.8264 15.8195 6.07129L14.2154 8.37511ZM17.0382 7.87221C17.6804 6.95286 17.4538 5.68816 16.5345 5.04801L14.9303 7.35171C14.5772 7.10581 14.4894 6.6188 14.7368 6.26463L17.0382 7.87221ZM16.5345 5.04796C16.0521 4.71207 15.5354 4.43718 14.9938 4.22703L13.9783 6.84413C14.3111 6.97329 14.6303 7.14283 14.9304 7.35176L16.5345 5.04796ZM15.4294 6.57491C16.3505 5.73884 16.9347 4.52746 16.9347 3.18159H14.1275C14.1275 3.69958 13.9049 4.16745 13.5427 4.49625L15.4294 6.57491ZM16.9347 3.18161C16.9348 0.649805 14.8743 -1.40361 12.3441 -1.40361V1.40361C13.3285 1.40361 14.1275 2.20475 14.1275 3.18156L16.9347 3.18161ZM12.3441 -1.40361C9.81375 -1.40361 7.75338 0.649832 7.75338 3.18165H10.5606C10.5606 2.20472 11.3596 1.40361 12.3441 1.40361V-1.40361ZM7.75338 3.18165C7.75338 4.52207 8.33294 5.72914 9.24762 6.56482L11.1411 4.49234C10.7814 4.16371 10.5606 3.69754 10.5606 3.18165H7.75338ZM9.6909 4.21837C9.58306 4.25981 9.47614 4.30382 9.37015 4.35038L10.4993 6.92053C10.5651 6.89159 10.6313 6.86435 10.6978 6.83879L9.6909 4.21837ZM9.37018 4.35037C8.88816 4.56212 8.43319 4.82281 8.00967 5.13012L9.65834 7.40222C9.91855 7.21341 10.1992 7.05236 10.4992 6.92054L9.37018 4.35037ZM10.1357 5.74105C9.45733 4.05954 7.80637 2.86591 5.87613 2.86591V5.67313C6.62197 5.67313 7.26731 6.13438 7.53232 6.79129L10.1357 5.74105ZM5.87613 2.86591C3.3458 2.86591 1.28543 4.91935 1.28543 7.45117H4.09266C4.09266 6.47425 4.89169 5.67313 5.87613 5.67313V2.86591ZM1.28543 7.45117C1.28543 8.78766 1.86164 9.9916 2.77159 10.827L4.67003 8.759C4.31219 8.43048 4.09266 7.96555 4.09266 7.45117H1.28543ZM3.229 8.47835C1.16019 9.25231 -0.544186 10.9227 -1.24411 13.0952L1.42787 13.956C1.84699 12.6551 2.89138 11.6019 4.21263 11.1076L3.229 8.47835ZM-1.2441 13.0952C-1.5675 14.0989 -1.39379 15.1773 -0.772043 16.029L1.49523 14.3737C1.403 14.2473 1.38013 14.1042 1.42787 13.956L-1.2441 13.0952ZM-0.772062 16.0289C-0.150569 16.8802 0.823071 17.3742 1.87672 17.3742V14.567C1.71835 14.567 1.5876 14.5002 1.49525 14.3737L-0.772062 16.0289ZM1.87672 17.3742H7.31353V14.567H1.87672V17.3742ZM7.31353 17.3742C8.43165 17.3742 9.34205 16.4687 9.34205 15.3468H6.53483C6.53483 14.9139 6.88571 14.567 7.31353 14.567V17.3742ZM9.34205 15.3468C9.34205 14.225 8.43172 13.3192 7.3135 13.3192V16.1265C6.88551 16.1265 6.53483 15.7795 6.53483 15.3468H9.34205ZM12.3441 2.6513C12.6394 2.6513 12.8777 2.89271 12.8777 3.18162H15.685C15.685 1.33778 14.1852 -0.155929 12.3441 -0.155929V2.6513ZM12.8777 3.18162C12.8777 3.47052 12.6394 3.71194 12.3441 3.71194V6.51916C14.1852 6.51916 15.685 5.02545 15.685 3.18162H12.8777ZM12.3441 3.71194C12.0488 3.71194 11.8105 3.47053 11.8105 3.18162H9.00324C9.00324 5.02545 10.503 6.51916 12.3441 6.51916V3.71194ZM11.8105 3.18162C11.8105 2.89271 12.0488 2.6513 12.3441 2.6513V-0.155929C10.503 -0.155929 9.00324 1.33778 9.00324 3.18162H11.8105ZM5.87616 6.92079C6.17144 6.92079 6.4098 7.1622 6.4098 7.45111H9.21703C9.21703 5.60727 7.71729 4.11356 5.87616 4.11356V6.92079ZM6.4098 7.45111C6.4098 7.74001 6.17144 7.98143 5.87616 7.98143V10.7887C7.71729 10.7887 9.21703 9.29494 9.21703 7.45111H6.4098ZM5.87616 7.98143C5.58088 7.98143 5.34252 7.74001 5.34252 7.45111H2.53529C2.53529 9.29494 4.03503 10.7887 5.87616 10.7887V7.98143ZM5.34252 7.45111C5.34252 7.1622 5.58088 6.92079 5.87616 6.92079V4.11356C4.03503 4.11356 2.53529 5.60727 2.53529 7.45111H5.34252Z"
        fill="#B7B7B7"
        mask="url(#path-1-inside-1_3505_2806)"
      />
      <path
        d="M13.99 13.0002L15.8462 11.144C16.0513 10.9389 16.0513 10.6064 15.8462 10.4017L15.5987 10.1542C15.3936 9.94905 15.0611 9.94905 14.8563 10.1542L13.0002 12.0103L11.144 10.1538C10.9389 9.94873 10.6064 9.94873 10.4017 10.1538L10.1538 10.4013C9.94873 10.6064 9.94873 10.9389 10.1538 11.1437L12.0103 13.0002L10.1542 14.8563C9.94905 15.0615 9.94905 15.394 10.1542 15.5987L10.4017 15.8462C10.6067 16.0513 10.9392 16.0513 11.144 15.8462L13.0002 13.99L14.8563 15.8462C15.0615 16.0513 15.394 16.0513 15.5987 15.8462L15.8462 15.5987C16.0513 15.3936 16.0513 15.0611 15.8462 14.8563L13.99 13.0002Z"
        fill="#E06C51"
      />
    </svg>
  )
}

export const IconEventNumber4 = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17.3334C4.58172 17.3334 1 13.7517 1 9.33337C1 4.9151 4.58172 1.33337 9 1.33337C13.4183 1.33337 17 4.9151 17 9.33337C17 13.7517 13.4183 17.3334 9 17.3334ZM9 15.7334C12.5346 15.7334 15.4 12.868 15.4 9.33337C15.4 5.79875 12.5346 2.93337 9 2.93337C5.46538 2.93337 2.6 5.79875 2.6 9.33337C2.6 12.868 5.46538 15.7334 9 15.7334ZM9 11.7334C8.55817 11.7334 8.2 11.3752 8.2 10.9334C8.2 10.4915 8.55817 10.1334 9 10.1334C9.88366 10.1334 10.6 9.41703 10.6 8.53337C10.6 7.64972 9.88366 6.93337 9 6.93337C8.11634 6.93337 7.4 7.64972 7.4 8.53337C7.4 8.9752 7.04183 9.33337 6.6 9.33337C6.15817 9.33337 5.8 8.9752 5.8 8.53337C5.8 6.76606 7.23269 5.33337 9 5.33337C10.7673 5.33337 12.2 6.76606 12.2 8.53337C12.2 10.3007 10.7673 11.7334 9 11.7334ZM9 14.1334C8.55817 14.1334 8.2 13.7752 8.2 13.3334C8.2 12.8915 8.55817 12.5334 9 12.5334C9.44183 12.5334 9.8 12.8915 9.8 13.3334C9.8 13.7752 9.44183 14.1334 9 14.1334Z"
        fill="#B7B7B7"
        stroke="white"
        strokeWidth="0.3"
      />
    </svg>
  )
}

export const IconEventNumber5 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99999 4.33333C10.5267 4.33333 12.78 5.75333 13.88 8C12.78 10.2467 10.5333 11.6667 7.99999 11.6667C5.46666 11.6667 3.21999 10.2467 2.11999 8C3.21999 5.75333 5.47332 4.33333 7.99999 4.33333ZM7.99999 3C4.66666 3 1.81999 5.07333 0.666656 8C1.81999 10.9267 4.66666 13 7.99999 13C11.3333 13 14.18 10.9267 15.3333 8C14.18 5.07333 11.3333 3 7.99999 3ZM7.99999 6.33333C8.91999 6.33333 9.66666 7.08 9.66666 8C9.66666 8.92 8.91999 9.66667 7.99999 9.66667C7.07999 9.66667 6.33332 8.92 6.33332 8C6.33332 7.08 7.07999 6.33333 7.99999 6.33333ZM7.99999 5C6.34666 5 4.99999 6.34667 4.99999 8C4.99999 9.65333 6.34666 11 7.99999 11C9.65332 11 11 9.65333 11 8C11 6.34667 9.65332 5 7.99999 5Z"
        fill="#B7B7B7"
      />
    </svg>
  )
}

// profile

export const IconProfileInfo = ({ color = "white" }) => {
  return (
    <svg
      className="icon-info"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_292_7830)">
        <path
          d="M2.50016 10.0002C2.50016 5.85803 5.85803 2.50016 10.0002 2.50016C14.1423 2.50016 17.5002 5.85803 17.5002 10.0002C17.5002 14.1423 14.1423 17.5002 10.0002 17.5002C5.85803 17.5002 2.50016 14.1423 2.50016 10.0002ZM10.0002 0.833496C4.93755 0.833496 0.833496 4.93755 0.833496 10.0002C0.833496 15.0628 4.93755 19.1668 10.0002 19.1668C15.0628 19.1668 19.1668 15.0628 19.1668 10.0002C19.1668 4.93755 15.0628 0.833496 10.0002 0.833496ZM8.7793 7.19726C8.46906 7.52585 8.3335 7.91156 8.3335 8.16683C8.3335 8.62707 7.9604 9.00016 7.50016 9.00016C7.03993 9.00016 6.66683 8.62707 6.66683 8.16683C6.66683 7.4221 7.01221 6.64114 7.56744 6.05307C8.13788 5.44889 8.97456 5.00016 10.0002 5.00016C10.9802 5.00016 11.8279 5.35999 12.4287 5.98708C13.0243 6.60872 13.3335 7.44687 13.3335 8.3335C13.3335 9.28867 12.902 10.1074 12.329 10.7232C11.7582 11.3367 11.0109 11.7917 10.2637 12.0407C9.82707 12.1863 9.35513 11.9503 9.20959 11.5137C9.06405 11.0771 9.30002 10.6051 9.73664 10.4596C10.2395 10.292 10.7422 9.9819 11.1088 9.58784C11.4734 9.19608 11.6668 8.76478 11.6668 8.3335C11.6668 7.83366 11.4951 7.42181 11.2252 7.14007C10.9605 6.86377 10.5582 6.66683 10.0002 6.66683C9.48766 6.66683 9.07434 6.88477 8.7793 7.19726ZM10.8335 14.1668C10.8335 14.6271 10.4604 15.0002 10.0002 15.0002C9.53992 15.0002 9.16683 14.6271 9.16683 14.1668C9.16683 13.7066 9.53992 13.3335 10.0002 13.3335C10.4604 13.3335 10.8335 13.7066 10.8335 14.1668Z"
          fill={color === "dark" ? "#0B0C0E" : "#fff"}
        />
      </g>
      <defs>
        <clipPath id="clip0_292_7830">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconCheck = ({ color = "white" }) => {
  return (
    <svg
      className="icon-check"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6666 5L7.49992 14.1667L3.33325 10"
        stroke={color === "dark" ? "#0B0C0E" : "#fff"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconUpgrade = ({ color = "white" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_292_7378)">
        <path
          d="M2.49992 10.0002C2.49992 5.85803 5.85778 2.50016 9.99992 2.50016C14.1421 2.50016 17.4999 5.85803 17.4999 10.0002C17.4999 14.1423 14.1421 17.5002 9.99992 17.5002C5.85778 17.5002 2.49992 14.1423 2.49992 10.0002ZM9.99992 0.833496C4.93731 0.833496 0.833252 4.93755 0.833252 10.0002C0.833252 15.0628 4.93731 19.1668 9.99992 19.1668C15.0625 19.1668 19.1666 15.0628 19.1666 10.0002C19.1666 4.93755 15.0625 0.833496 9.99992 0.833496ZM13.0892 8.57757L10.5892 6.07757C10.2637 5.75214 9.7361 5.75214 9.41066 6.07757L6.91066 8.57757C6.58523 8.90301 6.58523 9.43065 6.91066 9.75608C7.2361 10.0815 7.76374 10.0815 8.08917 9.75608L9.16658 8.67867V13.3335C9.16658 13.7937 9.53968 14.1668 9.99992 14.1668C10.4602 14.1668 10.8333 13.7937 10.8333 13.3335V8.67867L11.9107 9.75608C12.2361 10.0815 12.7637 10.0815 13.0892 9.75608C13.4146 9.43065 13.4146 8.90301 13.0892 8.57757Z"
          fill={color === "dark" ? "#0B0C0E" : "#fff"}
        />
      </g>
      <defs>
        <clipPath id="clip0_292_7378">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconChange = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.67 3.76122L4.0724 12.3588C3.08687 13.3443 3.08687 14.9422 4.07239 15.9277C5.05792 16.9132 6.65577 16.9132 7.64129 15.9277L16.2389 7.33012C16.8092 6.75982 16.8092 5.83517 16.2389 5.26487L14.7352 3.76122C14.1649 3.19092 13.2403 3.19092 12.67 3.76122ZM11.1481 7.15945L13.6081 4.69941C13.6603 4.64725 13.7449 4.64725 13.797 4.69941L15.3007 6.20306C15.3528 6.25521 15.3528 6.33978 15.3007 6.39193L12.8406 8.85197L11.1481 7.15945ZM10.2099 8.09764L5.01058 13.297C4.54321 13.7644 4.5432 14.5221 5.01058 14.9895C5.47796 15.4569 6.23573 15.4569 6.7031 14.9895L11.9024 9.79016L10.2099 8.09764Z"
        fill="#6D6D6E"
      />
    </svg>
  )
}

// create Event

export const IconLoadFile = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1206 2.709V14.75"
        stroke="#0B0C0E"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.20459 5.63574L12.1206 2.70774L15.0366 5.63574"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.63 8.14026C4.05 8.47026 2.75 9.81026 2.75 15.1403C2.75 22.2413 5.06 22.2413 12 22.2413C18.94 22.2413 21.25 22.2413 21.25 15.1403C21.25 9.81026 19.95 8.47026 16.37 8.14026"
        stroke="#0B0C0E"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconDeleteFile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.2248 18.8248L5.1748 17.7748L10.9498 11.9998L5.1748 6.2248L6.2248 5.1748L11.9998 10.9498L17.7748 5.1748L18.8248 6.2248L13.0498 11.9998L18.8248 17.7748L17.7748 18.8248L11.9998 13.0498L6.2248 18.8248Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconCompletedFile = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3332 4L5.99984 11.3333L2.6665 8"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconisLoadingFile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1599 8.3L14.4899 2.9C13.7599 2.8 12.9399 2.75 12.0399 2.75C5.7499 2.75 3.6499 5.07 3.6499 12C3.6499 18.94 5.7499 21.25 12.0399 21.25C18.3399 21.25 20.4399 18.94 20.4399 12C20.4399 10.58 20.3499 9.35 20.1599 8.3Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9336 2.83301V5.49401C13.9336 7.35201 15.4396 8.85701 17.2976 8.85701H20.2486"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6592 9.97656V16.0176"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0045 12.3316L11.6595 9.97656L9.31445 12.3316"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconDelete = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.1502 12.5492L3.4502 11.8492L7.30019 7.99922L3.4502 4.14922L4.1502 3.44922L8.00019 7.29922L11.8502 3.44922L12.5502 4.14922L8.70019 7.99922L12.5502 11.8492L11.8502 12.5492L8.00019 8.69922L4.1502 12.5492Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconCalendar = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.83301 8.51665C1.83301 3.87932 3.37901 2.33398 8.01567 2.33398C12.653 2.33398 14.199 3.87932 14.199 8.51665C14.199 13.154 12.653 14.6993 8.01567 14.6993C3.37901 14.6993 1.83301 13.154 1.83301 8.51665Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.0166 6.21615H14.0219"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9519 8.84115H10.9579"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0193 8.84115H8.0253"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.08082 8.84115H5.08682"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9519 11.4095H10.9579"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0193 11.4095H8.0253"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.08082 11.4095H5.08682"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6883 1.36719V3.54185"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.34945 1.36719V3.54185"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconArrowLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
    >
      <path
        d="M0.25 5.59999C0.25 5.48828 0.311249 5.37657 0.433124 5.29148L6.68313 0.927923C6.86187 0.803125 7.13063 0.765598 7.36437 0.833233C7.59813 0.900432 7.75 1.06014 7.75 1.23643L7.75 9.96355C7.75 10.1398 7.59812 10.2995 7.36437 10.3667C7.13062 10.4344 6.86187 10.3969 6.68312 10.2721L0.433124 5.90849C0.311249 5.8234 0.25 5.71169 0.25 5.59999Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconArrowRight = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11.7899L10 7.99992L6 4.20992"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const IconAdress = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.32099 14.8705L7.92593 15.1668L7.53086 14.8705C3.8642 12.1205 2 9.79029 2 7.75942C2 4.53477 4.47617 1.8335 7.92593 1.8335C11.3757 1.8335 13.8519 4.53477 13.8519 7.75942C13.8519 9.79029 11.9877 12.1205 8.32099 14.8705ZM3.31687 7.75942C3.31687 9.18091 4.83502 11.1355 7.92593 13.5168C11.0168 11.1355 12.535 9.18091 12.535 7.75942C12.535 5.23772 10.6216 3.15037 7.92593 3.15037C5.23028 3.15037 3.31687 5.23772 3.31687 7.75942ZM7.92593 9.07629C7.19864 9.07629 6.60905 8.48671 6.60905 7.75942C6.60905 7.03213 7.19864 6.44255 7.92593 6.44255C8.65321 6.44255 9.2428 7.03213 9.2428 7.75942C9.2428 8.48671 8.65321 9.07629 7.92593 9.07629Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconClose = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.14995 12.55L3.44995 11.8499L7.29995 7.99995L3.44995 4.14995L4.14995 3.44995L7.99995 7.29995L11.8499 3.44995L12.55 4.14995L8.69995 7.99995L12.55 11.8499L11.8499 12.55L7.99995 8.69995L4.14995 12.55Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconArrowUp = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.28 11.0327C13.1533 11.0327 13.0267 10.9861 12.9267 10.8861L8.58001 6.5394C8.26001 6.2194 7.74001 6.2194 7.42001 6.5394L3.07335 10.8861C2.88001 11.0794 2.56001 11.0794 2.36668 10.8861C2.17335 10.6927 2.17335 10.3727 2.36668 10.1794L6.71335 5.83273C7.42001 5.12607 8.57335 5.12607 9.28668 5.83273L13.6333 10.1794C13.8267 10.3727 13.8267 10.6927 13.6333 10.8861C13.5333 10.9794 13.4067 11.0327 13.28 11.0327Z"
        fill="#292D32"
      />
    </svg>
  )
}

export const IconArrowUpFat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L11.2929 8.29289C11.6834 7.90237 12.3166 7.90237 12.7071 8.29289L18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071L12 10.4142L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071Z"
        fill="black"
      />
    </svg>
  )
}

export const IconArrowDown = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00001 11.7004C7.53335 11.7004 7.06668 11.5204 6.71335 11.1671L2.36668 6.82042C2.17335 6.62708 2.17335 6.30708 2.36668 6.11375C2.56001 5.92042 2.88001 5.92042 3.07335 6.11375L7.42001 10.4604C7.74001 10.7804 8.26001 10.7804 8.58001 10.4604L12.9267 6.11375C13.12 5.92042 13.44 5.92042 13.6333 6.11375C13.8267 6.30708 13.8267 6.62708 13.6333 6.82042L9.28668 11.1671C8.93335 11.5204 8.46668 11.7004 8.00001 11.7004Z"
        fill="#292D32"
      />
    </svg>
  )
}

export const IconArrowDownFat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.62988 6L8.41988 10L12.2099 6"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const IconArrowPreview = () => {
  return (
    <svg
      height="20"
      width="20"
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
    </svg>
  )
}

export const IconCrown = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.86 7.14291C22.6908 6.99539 22.4816 6.90148 22.2589 6.8731C22.0362 6.84472 21.8102 6.88316 21.6094 6.98353L16.9022 9.32728L12.9722 2.79947C12.8712 2.63196 12.7286 2.4934 12.5582 2.39721C12.3879 2.30103 12.1956 2.25049 12 2.25049C11.8044 2.25049 11.6121 2.30103 11.4418 2.39721C11.2714 2.4934 11.1288 2.63196 11.0278 2.79947L7.09781 9.33009L2.3925 6.98634C2.19219 6.88686 1.96697 6.84876 1.74509 6.87682C1.52321 6.90488 1.31455 6.99784 1.14531 7.14405C0.976076 7.29025 0.853789 7.48319 0.7938 7.69864C0.733812 7.91409 0.738794 8.14246 0.808121 8.35509L4.27687 18.9826C4.31175 19.0894 4.37016 19.1869 4.44779 19.2681C4.52542 19.3493 4.62029 19.412 4.7254 19.4516C4.83051 19.4912 4.94317 19.5066 5.05506 19.4969C5.16695 19.4871 5.27522 19.4523 5.37187 19.3951C5.39531 19.381 7.7925 18.0001 12 18.0001C16.2075 18.0001 18.6047 19.381 18.6262 19.3942C18.7229 19.4519 18.8314 19.4872 18.9436 19.4973C19.0557 19.5074 19.1687 19.4921 19.2742 19.4526C19.3797 19.4131 19.4749 19.3503 19.5527 19.2689C19.6306 19.1875 19.6892 19.0897 19.7241 18.9826L23.1928 8.3579C23.2641 8.14522 23.2706 7.91612 23.2113 7.69976C23.152 7.4834 23.0297 7.28956 22.86 7.14291ZM16.485 14.7001C16.4544 14.8736 16.3637 15.0308 16.2288 15.1441C16.0939 15.2574 15.9234 15.3196 15.7472 15.3198C15.7032 15.3197 15.6593 15.316 15.6159 15.3085C13.2203 14.8973 10.7722 14.8973 8.37656 15.3085C8.27954 15.3256 8.18011 15.3235 8.08393 15.3022C7.98775 15.2808 7.89672 15.2408 7.81602 15.1843C7.65304 15.0702 7.54206 14.896 7.5075 14.7001C7.47294 14.5042 7.51762 14.3025 7.63173 14.1396C7.74583 13.9766 7.92001 13.8656 8.11593 13.831C10.684 13.3898 13.3085 13.3898 15.8766 13.831C15.9739 13.8477 16.067 13.8834 16.1505 13.9362C16.2341 13.9889 16.3063 14.0576 16.3632 14.1384C16.4201 14.2191 16.4605 14.3103 16.482 14.4067C16.5036 14.5031 16.5058 14.6028 16.4887 14.7001H16.485Z"
        fill="#F9B81A"
      />
    </svg>
  )
}
// messages

export const IconPlus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 4.16667V15.8333"
        stroke="#6D6D6E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16663 10H15.8333"
        stroke="#6D6D6E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconArrowBottomFat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
    >
      <path
        d="M4.5 5.5C4.40691 5.5 4.31382 5.45917 4.24291 5.37792L0.606612 1.21125C0.502614 1.09208 0.471342 0.912917 0.527705 0.757083C0.583704 0.60125 0.716792 0.5 0.863699 0.5L8.1363 0.5C8.28321 0.5 8.4163 0.60125 8.4723 0.757083C8.52866 0.912917 8.49739 1.09208 8.39339 1.21125L4.75709 5.37792C4.68618 5.45917 4.59309 5.5 4.5 5.5Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconChat = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.10513 6.05421L6.10523 6.0541C9.5093 2.64878 15.0404 2.64878 18.4445 6.05322C21.8549 9.46396 21.8488 14.9903 18.4445 18.395C16.6898 20.1499 14.3813 20.9994 12.0855 20.9498C10.4315 20.914 8.15767 20.9092 6.30057 20.9132C5.37133 20.9152 4.54521 20.9194 3.95139 20.9232C3.78256 20.9242 3.6325 20.9253 3.50417 20.9262L3.50786 20.4681C3.51258 19.8673 3.51884 19.0315 3.52502 18.0908C3.53738 16.2098 3.54944 13.9083 3.54819 12.23C3.54653 9.99489 4.3971 7.76187 6.10513 6.05421ZM8.46594 13.1068H8.56468V12.1068H8.46594V13.1068ZM12.2002 13.1069H12.2989V12.1069H12.2002V13.1069ZM15.9345 13.1068H16.0333V12.1068H15.9345V13.1068Z"
        stroke="#363C3E"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const IconArrowLeftFat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
    >
      <path
        d="M0.25 5.59999C0.25 5.48828 0.311249 5.37657 0.433124 5.29148L6.68313 0.927923C6.86187 0.803125 7.13063 0.765598 7.36437 0.833233C7.59813 0.900432 7.75 1.06014 7.75 1.23643L7.75 9.96355C7.75 10.1398 7.59812 10.2995 7.36437 10.3667C7.13062 10.4344 6.86187 10.3969 6.68312 10.2721L0.433124 5.90849C0.311249 5.8234 0.25 5.71169 0.25 5.59999Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconArrowMessage = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#263238" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6622 16.2921C15.6622 16.2921 7.67777 14.6404 10.4524 13.0387C12.7938 11.6871 20.8631 9.36345 21.9905 9.96385C22.5909 11.0912 20.2672 19.1605 18.9156 21.5019C17.3139 24.2765 15.6622 16.2921 15.6622 16.2921Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6621 16.2921L21.9904 9.96384"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconImport = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.9093 11.0933V2.0625"
        stroke="#6D6D6E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0963 8.89816L8.90929 11.0942L6.72229 8.89816"
        stroke="#6D6D6E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2777 5.44403C14.962 5.69153 15.9377 6.69653 15.9377 10.694C15.9377 16.019 14.2045 16.019 9.00024 16.019C3.79449 16.019 2.06274 16.019 2.06274 10.694C2.06274 6.69653 3.03774 5.69153 5.72274 5.44403"
        stroke="#6D6D6E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconSort = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.96282 3.22472C8.04265 3.11411 8.20735 3.11411 8.28718 3.22472L10.6025 6.43296C10.698 6.56523 10.6035 6.75 10.4403 6.75H5.80965C5.64653 6.75 5.55202 6.56523 5.64748 6.43296L7.96282 3.22472Z"
        fill="#263238"
      />
      <path
        d="M7.96282 12.7753C8.04265 12.8859 8.20735 12.8859 8.28718 12.7753L10.6025 9.56704C10.698 9.43477 10.6035 9.25 10.4403 9.25H5.80965C5.64653 9.25 5.55202 9.43477 5.64748 9.56704L7.96282 12.7753Z"
        fill="#263238"
      />
    </svg>
  )
}

export const IconCheckbox = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <rect
        x="0.5"
        y="1"
        width="15"
        height="15"
        rx="1.5"
        stroke="#6D6D6E"
        strokeOpacity="0.15"
      />
      <path
        d="M3.91308 7.53516H3.91326C3.99256 7.53525 4.07081 7.55331 4.14213 7.58798C4.21341 7.62262 4.27591 7.67295 4.32497 7.7352L3.91308 7.53516ZM3.91308 7.53516H3.09394C2.89031 7.53516 2.7766 7.76975 2.90232 7.9292L2.90237 7.92927L6.11214 11.9957L6.11218 11.9957C6.32247 12.2619 6.72568 12.2611 6.93667 11.9962L6.93708 11.9957L12.6597 4.74398C12.6598 4.74378 12.66 4.74358 12.6602 4.74338C12.7884 4.58295 12.6699 4.35 12.4689 4.35H11.6498C11.4894 4.35 11.3367 4.4235 11.2376 4.55044C11.2375 4.55055 11.2374 4.55066 11.2373 4.55077L6.52403 10.5216M3.91308 7.53516L6.52403 10.5216M6.52403 10.5216L4.32506 7.73531L6.52403 10.5216Z"
        fill="#6D6D6E"
        stroke="#6D6D6E"
        strokeWidth="0.3"
      />
    </svg>
  )
}

export const IconContactsChange = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.204 4.51327L4.88697 14.8304C3.70435 16.013 3.70434 17.9304 4.88697 19.113C6.0696 20.2957 7.98702 20.2957 9.16965 19.113L19.4867 8.79595C20.1711 8.11159 20.1711 7.00201 19.4867 6.31765L17.6824 4.51327C16.998 3.82891 15.8884 3.82891 15.204 4.51327ZM13.3778 8.59114L16.3299 5.6391C16.3925 5.57651 16.4939 5.57651 16.5565 5.6391L18.3609 7.44347C18.4235 7.50606 18.4235 7.60754 18.3609 7.67012L15.4089 10.6222L13.3778 8.59114ZM12.252 9.71697L6.0128 15.9562C5.45194 16.517 5.45194 17.4264 6.01279 17.9872C6.57365 18.5481 7.48297 18.5481 8.04382 17.9872L14.283 11.748L12.252 9.71697Z"
        fill="#363C3E"
      />
    </svg>
  )
}

export const IconContactDelete = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1803 5.81972C10.1803 4.96641 10.872 4.27466 11.7253 4.27466C12.5786 4.27466 13.2704 4.96641 13.2704 5.81972H18.6781C19.1048 5.81972 19.4506 6.1656 19.4506 6.59225C19.4506 7.01891 19.1048 7.36479 18.6781 7.36479H17.9056V16.6352C17.9056 18.3418 16.5221 19.7253 14.8154 19.7253H8.63519C6.92856 19.7253 5.54506 18.3418 5.54506 16.6352V7.36479H4.77253C4.34587 7.36479 4 7.01891 4 6.59225C4 6.1656 4.34587 5.81972 4.77253 5.81972H10.1803ZM7.09013 7.36479V16.6352C7.09013 17.4885 7.78188 18.1802 8.63519 18.1802H14.8154C15.6688 18.1802 16.3605 17.4885 16.3605 16.6352V7.36479H7.09013ZM12.4979 11.2274C12.4979 10.8008 12.8437 10.4549 13.2704 10.4549C13.697 10.4549 14.0429 10.8008 14.0429 11.2274V14.3176C14.0429 14.7442 13.697 15.0901 13.2704 15.0901C12.8437 15.0901 12.4979 14.7442 12.4979 14.3176V11.2274ZM9.40772 11.2274C9.40772 10.8008 9.7536 10.4549 10.1803 10.4549C10.6069 10.4549 10.9528 10.8008 10.9528 11.2274V14.3176C10.9528 14.7442 10.6069 15.0901 10.1803 15.0901C9.7536 15.0901 9.40772 14.7442 9.40772 14.3176V11.2274Z"
        fill="#363C3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5945 6.21972H4.77253C4.58816 6.21972 4.41422 6.37322 4.41422 6.59225C4.41422 6.81129 4.58816 6.96479 4.77253 6.96479H5.95929V16.6352C5.95929 18.1342 7.17085 19.3253 8.63519 19.3253H14.8154C16.2798 19.3253 17.4914 18.1342 17.4914 16.6352V6.96479H18.6781C18.8625 6.96479 19.0364 6.81129 19.0364 6.59225C19.0364 6.37322 18.8625 6.21972 18.6781 6.21972H12.8562V5.81972C12.8562 5.17403 12.3363 4.67466 11.7253 4.67466C11.1143 4.67466 10.5945 5.17403 10.5945 5.81972V6.21972ZM6.67591 6.96479H16.7747V16.6352C16.7747 17.6961 15.9111 18.5802 14.8154 18.5802H8.63519C7.53959 18.5802 6.67591 17.6961 6.67591 16.6352V6.96479ZM13.2704 5.81972C13.2704 4.96641 12.5786 4.27466 11.7253 4.27466C10.872 4.27466 10.1803 4.96641 10.1803 5.81972H4.77253C4.34587 5.81972 4 6.1656 4 6.59225C4 7.01891 4.34587 7.36479 4.77253 7.36479H5.54506V16.6352C5.54506 18.3418 6.92856 19.7253 8.63519 19.7253H14.8154C16.5221 19.7253 17.9056 18.3418 17.9056 16.6352V7.36479H18.6781C19.1048 7.36479 19.4506 7.01891 19.4506 6.59225C19.4506 6.1656 19.1048 5.81972 18.6781 5.81972H13.2704ZM7.09013 16.6352C7.09013 17.4885 7.78188 18.1802 8.63519 18.1802H14.8154C15.6688 18.1802 16.3605 17.4885 16.3605 16.6352V7.36479H7.09013V16.6352ZM13.2704 10.8549C13.086 10.8549 12.9121 11.0084 12.9121 11.2274V14.3176C12.9121 14.5366 13.086 14.6901 13.2704 14.6901C13.4548 14.6901 13.6287 14.5366 13.6287 14.3176V11.2274C13.6287 11.0084 13.4548 10.8549 13.2704 10.8549ZM10.1803 10.8549C9.99589 10.8549 9.82195 11.0084 9.82195 11.2274V14.3176C9.82195 14.5366 9.99589 14.6901 10.1803 14.6901C10.3646 14.6901 10.5386 14.5366 10.5386 14.3176V11.2274C10.5386 11.0084 10.3646 10.8549 10.1803 10.8549ZM13.2704 10.4549C12.8437 10.4549 12.4979 10.8008 12.4979 11.2274V14.3176C12.4979 14.7442 12.8437 15.0901 13.2704 15.0901C13.697 15.0901 14.0429 14.7442 14.0429 14.3176V11.2274C14.0429 10.8008 13.697 10.4549 13.2704 10.4549ZM10.1803 10.4549C9.7536 10.4549 9.40772 10.8008 9.40772 11.2274V14.3176C9.40772 14.7442 9.7536 15.0901 10.1803 15.0901C10.6069 15.0901 10.9528 14.7442 10.9528 14.3176V11.2274C10.9528 10.8008 10.6069 10.4549 10.1803 10.4549Z"
        fill="#363C3E"
      />
    </svg>
  )
}

export const IconGuestDelete = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.48322 4.84976C8.48322 4.13867 9.05968 3.56221 9.77078 3.56221C10.4819 3.56221 11.0583 4.13867 11.0583 4.84976H15.5648C15.9203 4.84976 16.2085 5.13799 16.2085 5.49354C16.2085 5.84909 15.9203 6.13732 15.5648 6.13732H14.921V13.8626C14.921 15.2848 13.7681 16.4377 12.3459 16.4377H7.19567C5.77348 16.4377 4.62056 15.2848 4.62056 13.8626V6.13732H3.97678C3.62124 6.13732 3.33301 5.84909 3.33301 5.49354C3.33301 5.13799 3.62124 4.84976 3.97678 4.84976H8.48322ZM5.90811 6.13732V13.8626C5.90811 14.5737 6.48457 15.1502 7.19567 15.1502H12.3459C13.057 15.1502 13.6334 14.5737 13.6334 13.8626V6.13732H5.90811ZM10.4146 9.3562C10.4146 9.00065 10.7028 8.71242 11.0583 8.71242C11.4139 8.71242 11.7021 9.00065 11.7021 9.3562V11.9313C11.7021 12.2869 11.4139 12.5751 11.0583 12.5751C10.7028 12.5751 10.4146 12.2869 10.4146 11.9313V9.3562ZM7.83945 9.3562C7.83945 9.00065 8.12767 8.71242 8.48322 8.71242C8.83877 8.71242 9.127 9.00065 9.127 9.3562V11.9313C9.127 12.2869 8.83877 12.5751 8.48322 12.5751C8.12767 12.5751 7.83945 12.2869 7.83945 11.9313V9.3562Z"
        fill="#6D6D6E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.82841 5.1831H3.97678C3.82315 5.1831 3.67819 5.31101 3.67819 5.49354C3.67819 5.67607 3.82315 5.80398 3.97678 5.80398H4.96575V13.8626C4.96575 15.1118 5.97538 16.1044 7.19567 16.1044H12.3459C13.5662 16.1044 14.5758 15.1118 14.5758 13.8626V5.80398H15.5648C15.7184 5.80398 15.8634 5.67607 15.8634 5.49354C15.8634 5.31101 15.7184 5.1831 15.5648 5.1831H10.7131V4.84976C10.7131 4.31169 10.28 3.89554 9.77078 3.89554C9.26159 3.89554 8.82841 4.31169 8.82841 4.84976V5.1831ZM5.56293 5.80398H13.9786V13.8626C13.9786 14.7468 13.2589 15.4835 12.3459 15.4835H7.19567C6.28266 15.4835 5.56293 14.7468 5.56293 13.8626V5.80398ZM11.0583 4.84976C11.0583 4.13867 10.4819 3.56221 9.77078 3.56221C9.05968 3.56221 8.48322 4.13867 8.48322 4.84976H3.97678C3.62124 4.84976 3.33301 5.13799 3.33301 5.49354C3.33301 5.84909 3.62124 6.13732 3.97678 6.13732H4.62056V13.8626C4.62056 15.2848 5.77348 16.4377 7.19567 16.4377H12.3459C13.7681 16.4377 14.921 15.2848 14.921 13.8626V6.13732H15.5648C15.9203 6.13732 16.2085 5.84909 16.2085 5.49354C16.2085 5.13799 15.9203 4.84976 15.5648 4.84976H11.0583ZM5.90811 13.8626C5.90811 14.5737 6.48457 15.1502 7.19567 15.1502H12.3459C13.057 15.1502 13.6334 14.5737 13.6334 13.8626V6.13732H5.90811V13.8626ZM11.0583 9.04576C10.9047 9.04576 10.7597 9.17368 10.7597 9.3562V11.9313C10.7597 12.1138 10.9047 12.2418 11.0583 12.2418C11.212 12.2418 11.3569 12.1138 11.3569 11.9313V9.3562C11.3569 9.17368 11.212 9.04576 11.0583 9.04576ZM8.48322 9.04576C8.32958 9.04576 8.18463 9.17368 8.18463 9.3562V11.9313C8.18463 12.1138 8.32958 12.2418 8.48322 12.2418C8.63686 12.2418 8.78181 12.1138 8.78181 11.9313V9.3562C8.78181 9.17368 8.63686 9.04576 8.48322 9.04576ZM11.0583 8.71242C10.7028 8.71242 10.4146 9.00065 10.4146 9.3562V11.9313C10.4146 12.2869 10.7028 12.5751 11.0583 12.5751C11.4139 12.5751 11.7021 12.2869 11.7021 11.9313V9.3562C11.7021 9.00065 11.4139 8.71242 11.0583 8.71242ZM8.48322 8.71242C8.12767 8.71242 7.83945 9.00065 7.83945 9.3562V11.9313C7.83945 12.2869 8.12767 12.5751 8.48322 12.5751C8.83877 12.5751 9.127 12.2869 9.127 11.9313V9.3562C9.127 9.00065 8.83877 8.71242 8.48322 8.71242Z"
        fill="#6D6D6E"
      />
    </svg>
  )
}

export const IconSorting = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12V10.6667H6V12H2ZM2 8.66667V7.33333H10V8.66667H2ZM2 5.33333V4H14V5.33333H2Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconDeleteQuest = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.48371 4.84975C8.48371 4.13865 9.06017 3.56219 9.77126 3.56219C10.4824 3.56219 11.0588 4.13865 11.0588 4.84975H15.5653C15.9208 4.84975 16.209 5.13798 16.209 5.49353C16.209 5.84907 15.9208 6.1373 15.5653 6.1373H14.9215V13.8626C14.9215 15.2848 13.7686 16.4377 12.3464 16.4377H7.19616C5.77396 16.4377 4.62105 15.2848 4.62105 13.8626V6.1373H3.97727C3.62172 6.1373 3.3335 5.84907 3.3335 5.49353C3.3335 5.13798 3.62172 4.84975 3.97727 4.84975H8.48371ZM5.9086 6.1373V13.8626C5.9086 14.5737 6.48506 15.1502 7.19616 15.1502H12.3464C13.0575 15.1502 13.6339 14.5737 13.6339 13.8626V6.1373H5.9086ZM10.415 9.35619C10.415 9.00064 10.7033 8.71241 11.0588 8.71241C11.4144 8.71241 11.7026 9.00064 11.7026 9.35619V11.9313C11.7026 12.2868 11.4144 12.5751 11.0588 12.5751C10.7033 12.5751 10.415 12.2868 10.415 11.9313V9.35619ZM7.83993 9.35619C7.83993 9.00064 8.12816 8.71241 8.48371 8.71241C8.83926 8.71241 9.12749 9.00064 9.12749 9.35619V11.9313C9.12749 12.2868 8.83926 12.5751 8.48371 12.5751C8.12816 12.5751 7.83993 12.2868 7.83993 11.9313V9.35619Z"
        fill="#6D6D6E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8289 5.18308H3.97727C3.82363 5.18308 3.67868 5.311 3.67868 5.49353C3.67868 5.67605 3.82363 5.80397 3.97727 5.80397H4.96623V13.8626C4.96623 15.1118 5.97587 16.1044 7.19616 16.1044H12.3464C13.5667 16.1044 14.5763 15.1118 14.5763 13.8626V5.80397H15.5653C15.7189 5.80397 15.8638 5.67605 15.8638 5.49353C15.8638 5.311 15.7189 5.18308 15.5653 5.18308H10.7136V4.84975C10.7136 4.31167 10.2805 3.89553 9.77126 3.89553C9.26208 3.89553 8.8289 4.31167 8.8289 4.84975V5.18308ZM5.56342 5.80397H13.9791V13.8626C13.9791 14.7467 13.2594 15.4835 12.3464 15.4835H7.19616C6.28315 15.4835 5.56342 14.7467 5.56342 13.8626V5.80397ZM11.0588 4.84975C11.0588 4.13865 10.4824 3.56219 9.77126 3.56219C9.06017 3.56219 8.48371 4.13865 8.48371 4.84975H3.97727C3.62172 4.84975 3.3335 5.13798 3.3335 5.49353C3.3335 5.84907 3.62172 6.1373 3.97727 6.1373H4.62105V13.8626C4.62105 15.2848 5.77396 16.4377 7.19616 16.4377H12.3464C13.7686 16.4377 14.9215 15.2848 14.9215 13.8626V6.1373H15.5653C15.9208 6.1373 16.209 5.84907 16.209 5.49353C16.209 5.13798 15.9208 4.84975 15.5653 4.84975H11.0588ZM5.9086 13.8626C5.9086 14.5737 6.48506 15.1502 7.19616 15.1502H12.3464C13.0575 15.1502 13.6339 14.5737 13.6339 13.8626V6.1373H5.9086V13.8626ZM11.0588 9.04574C10.9052 9.04574 10.7602 9.17366 10.7602 9.35619V11.9313C10.7602 12.1138 10.9052 12.2417 11.0588 12.2417C11.2125 12.2417 11.3574 12.1138 11.3574 11.9313V9.35619C11.3574 9.17366 11.2125 9.04574 11.0588 9.04574ZM8.48371 9.04574C8.33007 9.04574 8.18512 9.17366 8.18512 9.35619V11.9313C8.18512 12.1138 8.33007 12.2417 8.48371 12.2417C8.63735 12.2417 8.7823 12.1138 8.7823 11.9313V9.35619C8.7823 9.17366 8.63735 9.04574 8.48371 9.04574ZM11.0588 8.71241C10.7033 8.71241 10.415 9.00064 10.415 9.35619V11.9313C10.415 12.2868 10.7033 12.5751 11.0588 12.5751C11.4144 12.5751 11.7026 12.2868 11.7026 11.9313V9.35619C11.7026 9.00064 11.4144 8.71241 11.0588 8.71241ZM8.48371 8.71241C8.12816 8.71241 7.83993 9.00064 7.83993 9.35619V11.9313C7.83993 12.2868 8.12816 12.5751 8.48371 12.5751C8.83926 12.5751 9.12749 12.2868 9.12749 11.9313V9.35619C9.12749 9.00064 8.83926 8.71241 8.48371 8.71241Z"
        fill="#6D6D6E"
      />
    </svg>
  )
}

export const IconLoadSmall = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11.9473H13V13H3V11.9473ZM8.55556 8.87976L11.9284 5.68444L12.7141 6.42877L8 10.8947L3.28596 6.42877L4.07163 5.68444L7.44444 8.87976V2.99997H8.55556V8.87976Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconArrowDownSmall = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6L8 10L12 6"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const IconLocation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
    >
      <circle cx="21" cy="21" r="21" fill="#F9B81A" />
      <path
        d="M21.4815 30.4088L20.8889 30.8533L20.2963 30.4088C14.7963 26.2838 12 22.7885 12 19.7422C12 14.9052 15.7143 10.8533 20.8889 10.8533C26.0635 10.8533 29.7778 14.9052 29.7778 19.7422C29.7778 22.7885 26.9815 26.2838 21.4815 30.4088ZM13.9753 19.7422C13.9753 21.8744 16.2525 24.8063 20.8889 28.3782C25.5252 24.8063 27.8025 21.8744 27.8025 19.7422C27.8025 15.9596 24.9324 12.8286 20.8889 12.8286C16.8454 12.8286 13.9753 15.9596 13.9753 19.7422ZM20.8889 21.7175C19.798 21.7175 18.9136 20.8331 18.9136 19.7422C18.9136 18.6512 19.798 17.7669 20.8889 17.7669C21.9798 17.7669 22.8642 18.6512 22.8642 19.7422C22.8642 20.8331 21.9798 21.7175 20.8889 21.7175Z"
        fill="white"
      />
    </svg>
  )
}

export const IconQR = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
    >
      <circle cx="21" cy="21" r="21" fill="#EE8A49" />
      <path
        d="M13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V15C11 12.7909 12.7909 11 15 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H15C13.8954 13 13 13.8954 13 15V16ZM11 26C11 25.4477 11.4477 25 12 25C12.5523 25 13 25.4477 13 26V27C13 28.1046 13.8954 29 15 29H16C16.5523 29 17 29.4477 17 30C17 30.5523 16.5523 31 16 31H15C12.7909 31 11 29.2091 11 27V26ZM31 16C31 16.5523 30.5523 17 30 17C29.4477 17 29 16.5523 29 16V15C29 13.8954 28.1046 13 27 13H26C25.4477 13 25 12.5523 25 12C25 11.4477 25.4477 11 26 11H27C29.2091 11 31 12.7909 31 15V16ZM29 26C29 25.4477 29.4477 25 30 25C30.5523 25 31 25.4477 31 26V27C31 29.2091 29.2091 31 27 31H26C25.4477 31 25 30.5523 25 30C25 29.4477 25.4477 29 26 29H27C28.1046 29 29 28.1046 29 27V26ZM20 18C20 17.4477 20.4477 17 21 17C21.5523 17 22 17.4477 22 18V24C22 24.5523 21.5523 25 21 25C20.4477 25 20 24.5523 20 24V18ZM24 18C24 17.4477 24.4477 17 25 17C25.5523 17 26 17.4477 26 18V24C26 24.5523 25.5523 25 25 25C24.4477 25 24 24.5523 24 24V18ZM16 18C16 17.4477 16.4477 17 17 17C17.5523 17 18 17.4477 18 18V24C18 24.5523 17.5523 25 17 25C16.4477 25 16 24.5523 16 24V18Z"
        fill="white"
      />
    </svg>
  )
}

export const IconOval = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
    >
      <circle
        cx="4.57153"
        cy="4.00006"
        r="3"
        stroke="#FD3434"
        strokeWidth="2"
      />
    </svg>
  )
}

export const IconMessage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.18297 8.64609C5.47047 8.2867 5.99488 8.22843 6.35427 8.51594L10.0004 11.4328L13.6464 8.51594C14.0058 8.22843 14.5302 8.2867 14.8177 8.64609C15.1053 9.00547 15.047 9.52988 14.6876 9.81739L11.0415 12.7343C10.4328 13.2212 9.5679 13.2212 8.9592 12.7343L5.31311 9.81739C4.95373 9.52988 4.89546 9.00547 5.18297 8.64609Z"
        fill="#6D6D6E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6053 2.84761C10.6058 2.29848 9.39487 2.29848 8.39531 2.84761L3.39531 5.59453C2.32938 6.18013 1.66699 7.29981 1.66699 8.51601V14.1667C1.66699 16.0076 3.15938 17.5 5.00033 17.5H15.0003C16.8413 17.5 18.3337 16.0076 18.3337 14.1667V8.51601C18.3337 7.2998 17.6713 6.18013 16.6053 5.59453L11.6053 2.84761ZM9.19782 4.30835C9.6976 4.03379 10.3031 4.03379 10.8028 4.30835L15.8028 7.05527C16.3358 7.34807 16.667 7.90791 16.667 8.51601V14.1667C16.667 15.0871 15.9208 15.8333 15.0003 15.8333H5.00033C4.07985 15.8333 3.33366 15.0871 3.33366 14.1667V8.51601C3.33366 7.90791 3.66485 7.34807 4.19782 7.05527L9.19782 4.30835Z"
        fill="#6D6D6E"
      />
      <path
        d="M5.18297 8.64609C5.47047 8.2867 5.99488 8.22843 6.35427 8.51594L10.0004 11.4328L13.6464 8.51594C14.0058 8.22843 14.5302 8.2867 14.8177 8.64609C15.1053 9.00547 15.047 9.52988 14.6876 9.81739L11.0415 12.7343C10.4328 13.2212 9.5679 13.2212 8.9592 12.7343L5.31311 9.81739C4.95373 9.52988 4.89546 9.00547 5.18297 8.64609Z"
        stroke="#6D6D6E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6053 2.84761C10.6058 2.29848 9.39487 2.29848 8.39531 2.84761L3.39531 5.59453C2.32938 6.18013 1.66699 7.29981 1.66699 8.51601V14.1667C1.66699 16.0076 3.15938 17.5 5.00033 17.5H15.0003C16.8413 17.5 18.3337 16.0076 18.3337 14.1667V8.51601C18.3337 7.2998 17.6713 6.18013 16.6053 5.59453L11.6053 2.84761ZM9.19782 4.30835C9.6976 4.03379 10.3031 4.03379 10.8028 4.30835L15.8028 7.05527C16.3358 7.34807 16.667 7.90791 16.667 8.51601V14.1667C16.667 15.0871 15.9208 15.8333 15.0003 15.8333H5.00033C4.07985 15.8333 3.33366 15.0871 3.33366 14.1667V8.51601C3.33366 7.90791 3.66485 7.34807 4.19782 7.05527L9.19782 4.30835Z"
        stroke="#6D6D6E"
      />
    </svg>
  )
}

export const IconOptions = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M12.8398 14C13.9444 14 14.8398 13.1046 14.8398 12C14.8398 10.8954 13.9444 10 12.8398 10C11.7353 10 10.8398 10.8954 10.8398 12C10.8398 13.1046 11.7353 14 12.8398 14Z"
        fill="#363C3E"
      />
      <path
        d="M6.83984 14C7.94441 14 8.83984 13.1046 8.83984 12C8.83984 10.8954 7.94441 10 6.83984 10C5.73527 10 4.83984 10.8954 4.83984 12C4.83984 13.1046 5.73527 14 6.83984 14Z"
        fill="#363C3E"
      />
      <path
        d="M18.8398 14C19.9444 14 20.8398 13.1046 20.8398 12C20.8398 10.8954 19.9444 10 18.8398 10C17.7353 10 16.8398 10.8954 16.8398 12C16.8398 13.1046 17.7353 14 18.8398 14Z"
        fill="#363C3E"
      />
    </svg>
  )
}

export const IconBook = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22.08C11.7 22.08 11.4 22.01 11.15 21.87C9.28 20.85 5.99 19.77 3.93 19.5L3.64 19.46C2.33 19.3 1.25 18.07 1.25 16.74V4.66C1.25 3.87 1.56 3.15 2.13 2.63C2.7 2.11 3.44 1.86 4.22 1.93C6.42 2.1 9.74 3.2 11.62 4.38L11.86 4.52C11.93 4.56 12.08 4.56 12.14 4.53L12.3 4.43C14.18 3.25 17.5 2.13 19.71 1.94C19.73 1.94 19.81 1.94 19.83 1.94C20.56 1.87 21.31 2.13 21.87 2.65C22.44 3.17 22.75 3.89 22.75 4.68V16.75C22.75 18.09 21.67 19.31 20.35 19.47L20.02 19.51C17.96 19.78 14.66 20.87 12.83 21.88C12.59 22.02 12.3 22.08 12 22.08ZM3.98 3.42C3.66 3.42 3.37 3.53 3.14 3.74C2.89 3.97 2.75 4.3 2.75 4.66V16.74C2.75 17.33 3.26 17.9 3.83 17.98L4.13 18.02C6.38 18.32 9.83 19.45 11.83 20.54C11.92 20.58 12.05 20.59 12.1 20.57C14.1 19.46 17.57 18.32 19.83 18.02L20.17 17.98C20.74 17.91 21.25 17.33 21.25 16.74V4.67C21.25 4.3 21.11 3.98 20.86 3.74C20.6 3.51 20.27 3.4 19.9 3.42C19.88 3.42 19.8 3.42 19.78 3.42C17.87 3.59 14.79 4.62 13.11 5.67L12.95 5.78C12.4 6.12 11.62 6.12 11.09 5.79L10.85 5.65C9.14 4.6 6.06 3.58 4.1 3.42C4.06 3.42 4.02 3.42 3.98 3.42Z"
        fill="#0B0C0E"
      />
      <path
        d="M12 21.24C11.59 21.24 11.25 20.9 11.25 20.49V5.49C11.25 5.08 11.59 4.74 12 4.74C12.41 4.74 12.75 5.08 12.75 5.49V20.49C12.75 20.91 12.41 21.24 12 21.24Z"
        fill="#0B0C0E"
      />
      <path
        d="M7.75 9.24H5.5C5.09 9.24 4.75 8.9 4.75 8.49C4.75 8.08 5.09 7.74 5.5 7.74H7.75C8.16 7.74 8.5 8.08 8.5 8.49C8.5 8.9 8.16 9.24 7.75 9.24Z"
        fill="#0B0C0E"
      />
      <path
        d="M8.5 12.24H5.5C5.09 12.24 4.75 11.9 4.75 11.49C4.75 11.08 5.09 10.74 5.5 10.74H8.5C8.91 10.74 9.25 11.08 9.25 11.49C9.25 11.9 8.91 12.24 8.5 12.24Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconNotifications = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33497 4.72727V5.25342C6.64516 6.35644 4.76592 9.97935 4.83412 13.1192L4.83409 14.8631C3.45713 16.6333 3.53815 19.2727 6.9735 19.2727H9.33497C9.33497 19.996 9.61684 20.6897 10.1186 21.2012C10.6203 21.7127 11.3008 22 12.0104 22C12.72 22 13.4005 21.7127 13.9022 21.2012C14.404 20.6897 14.6858 19.996 14.6858 19.2727H17.0538C20.4826 19.2727 20.5323 16.6278 19.1555 14.8576L19.1938 13.1216C19.2631 9.97811 17.3803 6.35194 14.6858 5.25049V4.72727C14.6858 4.00396 14.404 3.31026 13.9022 2.7988C13.4005 2.28734 12.72 2 12.0104 2C11.3008 2 10.6203 2.28734 10.1186 2.7988C9.61684 3.31026 9.33497 4.00395 9.33497 4.72727ZM12.9022 4.72727C12.9022 4.74573 12.9017 4.76414 12.9006 4.78246C12.6101 4.74603 12.3142 4.72727 12.014 4.72727C11.7113 4.72727 11.413 4.74634 11.1203 4.78335C11.1192 4.76474 11.1186 4.74603 11.1186 4.72727C11.1186 4.48617 11.2126 4.25494 11.3798 4.08445C11.547 3.91396 11.7739 3.81818 12.0104 3.81818C12.2469 3.81818 12.4738 3.91396 12.641 4.08445C12.8083 4.25494 12.9022 4.48617 12.9022 4.72727ZM11.1186 19.2727C11.1186 19.5138 11.2126 19.7451 11.3798 19.9156C11.547 20.086 11.7739 20.1818 12.0104 20.1818C12.2469 20.1818 12.4738 20.086 12.641 19.9156C12.8083 19.7451 12.9022 19.5138 12.9022 19.2727H11.1186ZM17.0538 17.4545C17.8157 17.4545 18.2267 16.5435 17.7309 15.9538C17.49 15.6673 17.3616 15.3028 17.3699 14.9286L17.4106 13.0808C17.4787 9.99416 15.0427 6.54545 12.014 6.54545C8.98598 6.54545 6.55028 9.99301 6.61731 13.0789L6.65748 14.9289C6.66561 15.303 6.53726 15.6674 6.29639 15.9538C5.80054 16.5435 6.21158 17.4545 6.9735 17.4545H17.0538Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconScan = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6C3 3.79086 4.79086 2 7 2H10.5455C11.0977 2 11.5455 2.44772 11.5455 3C11.5455 3.55228 11.0977 4 10.5455 4H7C5.89543 4 5 4.89543 5 6V7.90909C5 8.46138 4.55228 8.90909 4 8.90909C3.44772 8.90909 3 8.46138 3 7.90909V6ZM14.4545 3C14.4545 2.44772 14.9023 2 15.4545 2H19C21.2091 2 23 3.79086 23 6V7.90909C23 8.46138 22.5523 8.90909 22 8.90909C21.4477 8.90909 21 8.46138 21 7.90909V6C21 4.89543 20.1046 4 19 4H15.4545C14.9023 4 14.4545 3.55228 14.4545 3ZM1 12C1 11.4477 1.44772 11 2 11H24C24.5523 11 25 11.4477 25 12C25 12.5523 24.5523 13 24 13H2C1.44772 13 1 12.5523 1 12ZM4 15.0909C4.55228 15.0909 5 15.5386 5 16.0909V18C5 19.1046 5.89543 20 7 20H10.5455C11.0977 20 11.5455 20.4477 11.5455 21C11.5455 21.5523 11.0977 22 10.5455 22H7C4.79086 22 3 20.2091 3 18V16.0909C3 15.5386 3.44772 15.0909 4 15.0909ZM22 15.0909C22.5523 15.0909 23 15.5386 23 16.0909V18C23 20.2091 21.2091 22 19 22H15.4545C14.9023 22 14.4545 21.5523 14.4545 21C14.4545 20.4477 14.9023 20 15.4545 20H19C20.1046 20 21 19.1046 21 18V16.0909C21 15.5386 21.4477 15.0909 22 15.0909Z"
        fill="#0B0C0E"
        stroke="#0B0C0E"
        strokeWidth="0.4"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const IconReload = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_832_8295)">
        <path
          d="M16.5374 17.5675C14.7843 19.0832 12.4992 20.0002 9.99986 20.0002C4.47692 20.0002 -0.000305176 15.5229 -0.000305176 10C-0.000305176 4.47706 4.47692 -0.000167847 9.99986 -0.000167847C15.5227 -0.000167847 20 4.47706 20 10C20 12.1361 19.3302 14.1159 18.1892 15.7407L14.9999 10H18C18 5.58164 14.4182 1.99986 9.99986 1.99986C5.58151 1.99986 1.99973 5.58164 1.99973 10C1.99973 14.4184 5.58151 18.0001 9.99986 18.0001C12.1501 18.0001 14.1021 17.1518 15.5397 15.7717L16.5374 17.5675Z"
          fill="#0B0C0E"
        />
      </g>
      <defs>
        <clipPath id="clip0_832_8295">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconAlertCircle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clipPath="url(#clip0_832_8581)">
        <path
          d="M8.14305 14.6667C11.8249 14.6667 14.8097 11.6819 14.8097 8.00004C14.8097 4.31814 11.8249 1.33337 8.14305 1.33337C4.46115 1.33337 1.47638 4.31814 1.47638 8.00004C1.47638 11.6819 4.46115 14.6667 8.14305 14.6667Z"
          stroke="#FD3434"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.14307 5.33337V8.00004"
          stroke="#FD3434"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.14307 10.6667H8.14973"
          stroke="#FD3434"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_832_8581">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.142883)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconAlertOctagon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clipPath="url(#clip0_832_8613)">
        <path
          d="M5.38286 1.33333H10.9029L14.8095 5.24V10.76L10.9029 14.6667H5.38286L1.4762 10.76V5.24L5.38286 1.33333Z"
          stroke="#F9B81A"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.14288 5.33333V8"
          stroke="#F9B81A"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.14288 10.6667H8.14955"
          stroke="#F9B81A"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_832_8613">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.142883)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

//reminders

export const IconChat2 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.10513 6.05421L6.10523 6.0541C9.5093 2.64878 15.0404 2.64878 18.4445 6.05322C21.8549 9.46396 21.8488 14.9903 18.4445 18.395C16.6898 20.1499 14.3813 20.9994 12.0855 20.9498C10.4315 20.914 8.15767 20.9092 6.30057 20.9132C5.37133 20.9152 4.54521 20.9194 3.95139 20.9232C3.78256 20.9242 3.6325 20.9253 3.50417 20.9262L3.50786 20.4681C3.51258 19.8673 3.51884 19.0315 3.52502 18.0908C3.53738 16.2098 3.54944 13.9083 3.54819 12.23C3.54653 9.99489 4.3971 7.76187 6.10513 6.05421ZM8.46594 13.1068H8.56468V12.1068H8.46594V13.1068ZM12.2002 13.1069H12.2989V12.1069H12.2002V13.1069ZM15.9345 13.1068H16.0333V12.1068H15.9345V13.1068Z"
        stroke="#363C3E"
        strokeLinecap="round"
      />
    </svg>
  )
}

// test statuses

export const IconConfirm = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
        fill="#46BA65"
      />
      <path
        d="M10.3943 17.824C10.2634 17.9695 10.0848 18.0506 9.89925 18.0506C9.71372 18.0506 9.53511 17.9695 9.4042 17.824L5.45058 13.4553C5.04028 13.002 5.04028 12.267 5.45058 11.8145L5.94563 11.2675C6.35606 10.8142 7.02062 10.8142 7.43092 11.2675L9.89925 13.9946L16.5691 6.62569C16.9795 6.17239 17.6447 6.17239 18.0543 6.62569L18.5494 7.17276C18.9597 7.62606 18.9597 8.36097 18.5494 8.81356L10.3943 17.824Z"
        fill="white"
      />
    </svg>
  )
}

export const IconWaiting = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
        fill="#F9B819"
      />
      <path
        d="M16.1905 8.24306V7.14001C16.5021 6.95834 16.7143 6.62422 16.7143 6.23809V5.9762C16.7143 5.83143 16.5971 5.71429 16.4524 5.71429H7.54763C7.40286 5.71429 7.28571 5.83143 7.28571 5.9762V6.23811C7.28571 6.62422 7.49791 6.95834 7.80952 7.14004V8.24306C7.80952 9.28096 8.252 10.2744 9.0234 10.9685L10.1695 12L9.0234 13.0315C8.252 13.7257 7.80952 14.719 7.80952 15.7569V16.86C7.49791 17.0417 7.28571 17.3758 7.28571 17.7619V18.0238C7.28571 18.1686 7.40286 18.2857 7.54763 18.2857H16.4524C16.5972 18.2857 16.7143 18.1686 16.7143 18.0238V17.7619C16.7143 17.3758 16.5021 17.0417 16.1905 16.86V15.7569C16.1905 14.719 15.748 13.7257 14.9766 13.0315L13.8305 12L14.9766 10.9685C15.748 10.2744 16.1905 9.28094 16.1905 8.24306ZM14.2758 10.1899L12.6972 11.6107C12.5867 11.71 12.5238 11.8514 12.5238 12C12.5238 12.1486 12.5867 12.2901 12.6972 12.3893L14.2758 13.8101C14.8267 14.306 15.1429 15.0157 15.1429 15.7569V16.7143H14.488L12.2095 13.6763C12.1107 13.5443 11.8892 13.5443 11.7905 13.6763L9.51204 16.7143H8.85714V15.7569C8.85714 15.0157 9.17327 14.306 9.7242 13.81L11.3028 12.3892C11.4133 12.29 11.4762 12.1486 11.4762 12C11.4762 11.8514 11.4133 11.7099 11.3028 11.6107L9.7242 10.1899C9.17327 9.694 8.85714 8.98426 8.85714 8.24306V7.28571H15.1429V8.24306C15.1429 8.98426 14.8267 9.694 14.2758 10.1899Z"
        fill="white"
      />
      <path
        d="M13.8051 9.38094H10.1945C10.0909 9.38094 9.99701 9.44208 9.95507 9.53671C9.91313 9.63161 9.93076 9.7421 10.0006 9.81883L11.8242 11.5013C11.8741 11.5465 11.937 11.569 11.9999 11.569C12.0628 11.569 12.1257 11.5465 12.1756 11.5013L13.999 9.81883C14.0688 9.7421 14.0864 9.63161 14.0445 9.53671C14.0026 9.44208 13.9087 9.38094 13.8051 9.38094Z"
        fill="white"
      />
    </svg>
  )
}

export const IconSent = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.40594 17.8891C8.40594 17.7521 8.39071 17.6912 8.3298 17.6912L7.97957 17.8587C7.97957 17.7825 7.93389 17.7369 7.85775 17.7064L7.73593 17.6912C7.62934 17.6912 7.58365 17.7064 7.43138 17.7978C7.3857 17.7064 7.32479 17.5998 7.27911 17.5084C6.88319 16.7471 6.47205 15.605 6.28932 15.1025C6.19796 14.8436 6.10659 14.3107 6 13.5036C6.12182 13.5798 6.21318 13.6102 6.25887 13.6102C6.31978 13.6102 6.39591 13.5036 6.45682 13.2904C6.48728 13.3361 6.54819 13.3514 6.62433 13.3514C6.67001 13.3514 6.73092 13.3361 6.76137 13.2904L7.00501 12.925L7.27911 13.0164H7.29433C7.32479 13.0164 7.37047 12.9707 7.44661 12.925C7.52274 12.8793 7.58365 12.8488 7.62934 12.8488L7.67502 12.8641C7.91866 12.9859 8.08616 13.1991 8.1623 13.5341C8.34503 14.3107 8.51253 14.6914 8.71049 14.6914C8.87799 14.6914 9.1064 14.4934 9.35004 14.1127C9.59368 13.732 9.83732 13.2143 10.1114 12.59C10.1266 12.7118 10.1419 12.7727 10.1723 12.7727C10.2637 12.7727 10.4921 12.2398 11.0555 11.3413C11.893 9.98609 13.964 7.3822 14.4969 7.01674C14.8928 6.74264 15.1974 6.48378 15.4106 6.25537C15.3801 6.40764 15.3497 6.51423 15.3497 6.55991C15.3497 6.6056 15.3801 6.62082 15.4106 6.62082L15.8369 6.40764V6.46855C15.8369 6.54469 15.8522 6.59037 15.8978 6.59037C15.9587 6.59037 16.2024 6.34673 16.2328 6.25537L16.2024 6.46855L16.7201 6.164L16.5983 6.4381C16.7506 6.3315 16.8724 6.27059 16.9485 6.27059C17.0247 6.27059 17.0704 6.39241 17.0704 6.46855C17.0704 6.59037 16.9638 6.75787 16.7963 6.97106C16.6135 7.2147 16.1567 7.68675 14.7862 9.25517C14.1924 9.92518 11.558 13.5036 11.0555 14.3564L10.1114 15.9552C9.70027 16.6405 9.4414 17.0821 9.30436 17.2496C9.16731 17.4171 8.99981 17.5846 8.80185 17.7369L8.6648 17.6607L8.54298 17.7369L8.40594 17.8891Z"
        fill="#B3B2AD"
      />
    </svg>
  )
}

export const IconScanned = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13Z"
        fill="#EC7A30"
      />
      <path
        d="M9.66667 7.28571H8.71429C7.92667 7.28571 7.28571 7.92667 7.28571 8.71429V9.66667C7.28571 9.93 7.49905 10.1429 7.7619 10.1429C8.02476 10.1429 8.2381 9.93 8.2381 9.66667V8.71429C8.2381 8.45143 8.45191 8.2381 8.71429 8.2381H9.66667C9.92952 8.2381 10.1429 8.02524 10.1429 7.7619C10.1429 7.49857 9.92952 7.28571 9.66667 7.28571Z"
        fill="white"
      />
      <path
        d="M9.66667 17.7619H8.71429C8.45191 17.7619 8.2381 17.5486 8.2381 17.2857V16.3333C8.2381 16.07 8.02476 15.8571 7.7619 15.8571C7.49905 15.8571 7.28571 16.07 7.28571 16.3333V17.2857C7.28571 18.0733 7.92667 18.7143 8.71429 18.7143H9.66667C9.92952 18.7143 10.1429 18.5014 10.1429 18.2381C10.1429 17.9748 9.92952 17.7619 9.66667 17.7619Z"
        fill="white"
      />
      <path
        d="M17.2857 7.28571H16.3333C16.0705 7.28571 15.8571 7.49857 15.8571 7.7619C15.8571 8.02524 16.0705 8.2381 16.3333 8.2381H17.2857C17.5481 8.2381 17.7619 8.45143 17.7619 8.71429V9.66667C17.7619 9.93 17.9752 10.1429 18.2381 10.1429C18.501 10.1429 18.7143 9.93 18.7143 9.66667V8.71429C18.7143 7.92667 18.0733 7.28571 17.2857 7.28571Z"
        fill="white"
      />
      <path
        d="M18.2381 15.8571C17.9752 15.8571 17.7619 16.07 17.7619 16.3333V17.2857C17.7619 17.5486 17.5481 17.7619 17.2857 17.7619H16.3333C16.0705 17.7619 15.8571 17.9748 15.8571 18.2381C15.8571 18.5014 16.0705 18.7143 16.3333 18.7143H17.2857C18.0733 18.7143 18.7143 18.0733 18.7143 17.2857V16.3333C18.7143 16.07 18.501 15.8571 18.2381 15.8571Z"
        fill="white"
      />
      <path
        d="M18.2381 13.2666H7.7619C7.49905 13.2666 7.28571 13.0537 7.28571 12.7904C7.28571 12.527 7.49905 12.3142 7.7619 12.3142H18.2381C18.501 12.3142 18.7143 12.527 18.7143 12.7904C18.7143 13.0537 18.501 13.2666 18.2381 13.2666Z"
        fill="white"
      />
      <path
        d="M13 25.25C19.7655 25.25 25.25 19.7655 25.25 13C25.25 6.23451 19.7655 0.75 13 0.75C6.23451 0.75 0.75 6.23451 0.75 13C0.75 19.7655 6.23451 25.25 13 25.25Z"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  )
}

export const IconReject = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
        fill="#DADADA"
      />
      <path
        d="M13.8857 12.0004L17.4213 8.46478C17.8119 8.07413 17.8119 7.4408 17.4213 7.05077L16.9499 6.57943C16.5592 6.18866 15.9258 6.18866 15.5358 6.57943L12.0004 10.1149L8.46478 6.5787C8.07413 6.18805 7.4408 6.18805 7.05077 6.5787L6.5787 7.05003C6.18805 7.4408 6.18805 8.07413 6.5787 8.46417L10.1149 12.0004L6.57943 15.5358C6.18866 15.9266 6.18866 16.5599 6.57943 16.9499L7.05077 17.4213C7.44141 17.8119 8.07474 17.8119 8.46478 17.4213L12.0004 13.8857L15.5358 17.4213C15.9266 17.8119 16.5599 17.8119 16.9499 17.4213L17.4213 16.9499C17.8119 16.5592 17.8119 15.9258 17.4213 15.5358L13.8857 12.0004Z"
        fill="white"
      />
    </svg>
  )
}

export const IconRecieved = ({ color }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.40594 17.8891C2.40594 17.7521 2.39071 17.6912 2.3298 17.6912L1.97957 17.8587C1.97957 17.7825 1.93389 17.7369 1.85775 17.7064L1.73593 17.6912C1.62934 17.6912 1.58365 17.7064 1.43138 17.7978C1.3857 17.7064 1.32479 17.5998 1.27911 17.5084C0.883192 16.7471 0.472051 15.605 0.289321 15.1025C0.197957 14.8436 0.106592 14.3107 0 13.5036C0.12182 13.5798 0.213184 13.6102 0.258867 13.6102C0.319776 13.6102 0.395914 13.5036 0.456823 13.2904C0.487278 13.3361 0.548188 13.3514 0.624325 13.3514C0.670008 13.3514 0.730917 13.3361 0.761372 13.2904L1.00501 12.925L1.27911 13.0164H1.29433C1.32479 13.0164 1.37047 12.9707 1.44661 12.925C1.52274 12.8793 1.58365 12.8488 1.62934 12.8488L1.67502 12.8641C1.91866 12.9859 2.08616 13.1991 2.1623 13.5341C2.34503 14.3107 2.51253 14.6914 2.71049 14.6914C2.87799 14.6914 3.1064 14.4934 3.35004 14.1127C3.59368 13.732 3.83732 13.2143 4.11141 12.59C4.12664 12.7118 4.14187 12.7727 4.17232 12.7727C4.26368 12.7727 4.4921 12.2398 5.05551 11.3413C5.89302 9.98609 7.96395 7.3822 8.49691 7.01674C8.89283 6.74264 9.19738 6.48378 9.41056 6.25537C9.38011 6.40764 9.34965 6.51423 9.34965 6.55991C9.34965 6.6056 9.38011 6.62082 9.41056 6.62082L9.83693 6.40764V6.46855C9.83693 6.54469 9.85216 6.59037 9.89784 6.59037C9.95875 6.59037 10.2024 6.34673 10.2328 6.25537L10.2024 6.46855L10.7201 6.164L10.5983 6.4381C10.7506 6.3315 10.8724 6.27059 10.9485 6.27059C11.0247 6.27059 11.0704 6.39241 11.0704 6.46855C11.0704 6.59037 10.9638 6.75787 10.7963 6.97106C10.6135 7.2147 10.1567 7.68675 8.78624 9.25517C8.19237 9.92518 5.55802 13.5036 5.05551 14.3564L4.11141 15.9552C3.70027 16.6405 3.4414 17.0821 3.30436 17.2496C3.16731 17.4171 2.99981 17.5846 2.80185 17.7369L2.6648 17.6607L2.54298 17.7369L2.40594 17.8891Z"
        fill={color ? color : "#B3B2AD"}
      />
      <path
        d="M15.3356 17.8891C15.3356 17.7521 15.3204 17.6912 15.2594 17.6912L14.9092 17.8587C14.9092 17.7825 14.8635 17.7369 14.7874 17.7064L14.6656 17.6912C14.559 17.6912 14.5133 17.7064 14.361 17.7978C14.3153 17.7064 14.2544 17.5998 14.2088 17.5084C13.8128 16.7471 13.4017 15.605 13.219 15.1025C13.1276 14.8436 13.0362 14.3107 12.9296 13.5036C13.0515 13.5798 13.1428 13.6102 13.1885 13.6102C13.2494 13.6102 13.3256 13.5036 13.3865 13.2904C13.4169 13.3361 13.4778 13.3514 13.554 13.3514C13.5997 13.3514 13.6606 13.3361 13.691 13.2904L13.9347 12.925L14.2088 13.0164H14.224C14.2544 13.0164 14.3001 12.9707 14.3763 12.925C14.4524 12.8793 14.5133 12.8488 14.559 12.8488L14.6047 12.8641C14.8483 12.9859 15.0158 13.1991 15.0919 13.5341C15.2747 14.3107 15.4422 14.6914 15.6401 14.6914C15.8076 14.6914 16.036 14.4934 16.2797 14.1127C16.5233 13.732 16.767 13.2143 17.0411 12.59C17.0563 12.7118 17.0715 12.7727 17.102 12.7727C17.1933 12.7727 17.4217 12.2398 17.9852 11.3413C18.8227 9.98609 20.8936 7.3822 21.4266 7.01674C21.8225 6.74264 22.127 6.48378 22.3402 6.25537C22.3098 6.40764 22.2793 6.51423 22.2793 6.55991C22.2793 6.6056 22.3098 6.62082 22.3402 6.62082L22.7666 6.40764V6.46855C22.7666 6.54469 22.7818 6.59037 22.8275 6.59037C22.8884 6.59037 23.132 6.34673 23.1625 6.25537L23.132 6.46855L23.6498 6.164L23.5279 6.4381C23.6802 6.3315 23.802 6.27059 23.8782 6.27059C23.9543 6.27059 24 6.39241 24 6.46855C24 6.59037 23.8934 6.75787 23.7259 6.97106C23.5432 7.2147 23.0864 7.68675 21.7159 9.25517C21.122 9.92518 18.4877 13.5036 17.9852 14.3564L17.0411 15.9552C16.6299 16.6405 16.371 17.0821 16.234 17.2496C16.097 17.4171 15.9295 17.5846 15.7315 17.7369L15.5944 17.6607L15.4726 17.7369L15.3356 17.8891Z"
        fill={color ? color : "#B3B2AD"}
      />
    </svg>
  )
}

export const IconFailed = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
        fill="#EB5757"
      />
      <path
        d="M13.8857 12.0004L17.4213 8.46478C17.8119 8.07413 17.8119 7.4408 17.4213 7.05077L16.9499 6.57943C16.5592 6.18866 15.9258 6.18866 15.5358 6.57943L12.0004 10.1149L8.46478 6.5787C8.07413 6.18805 7.4408 6.18805 7.05077 6.5787L6.5787 7.05003C6.18805 7.4408 6.18805 8.07413 6.5787 8.46417L10.1149 12.0004L6.57943 15.5358C6.18866 15.9266 6.18866 16.5599 6.57943 16.9499L7.05077 17.4213C7.44141 17.8119 8.07474 17.8119 8.46478 17.4213L12.0004 13.8857L15.5358 17.4213C15.9266 17.8119 16.5599 17.8119 16.9499 17.4213L17.4213 16.9499C17.8119 16.5592 17.8119 15.9258 17.4213 15.5358L13.8857 12.0004Z"
        fill="white"
      />
    </svg>
  )
}

export const IconMail = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1659_20375)">
        <path
          d="M11.9999 2.3999C9.45382 2.3999 7.01203 3.41133 5.21168 5.21168C3.41133 7.01203 2.3999 9.45382 2.3999 11.9999C2.3999 14.546 3.41133 16.9878 5.21168 18.7881C7.01203 20.5885 9.45382 21.5999 11.9999 21.5999C12.2386 21.5999 12.4675 21.5051 12.6363 21.3363C12.8051 21.1675 12.8999 20.9386 12.8999 20.6999C12.8999 20.4612 12.8051 20.2323 12.6363 20.0635C12.4675 19.8947 12.2386 19.7999 11.9999 19.7999C10.4572 19.7999 8.94916 19.3424 7.66645 18.4854C6.38375 17.6283 5.38401 16.4101 4.79364 14.9848C4.20328 13.5596 4.04881 11.9912 4.34978 10.4782C4.65074 8.96515 5.39362 7.57532 6.48447 6.48447C7.57532 5.39362 8.96515 4.65074 10.4782 4.34978C11.9912 4.04881 13.5596 4.20328 14.9848 4.79364C16.4101 5.38401 17.6283 6.38375 18.4854 7.66645C19.3424 8.94916 19.7999 10.4572 19.7999 11.9999C19.7999 14.9129 19.2059 15.1499 18.4889 15.1499C16.9889 15.1499 16.9499 12.9059 16.9499 12.8829V11.9999C16.9537 10.8352 16.5481 9.70612 15.8039 8.81011C15.0597 7.9141 14.0243 7.30812 12.8787 7.09807C11.733 6.88803 10.55 7.08728 9.53631 7.661C8.52266 8.23473 7.74288 9.14644 7.33324 10.2368C6.92361 11.3271 6.91018 12.5267 7.29531 13.626C7.68043 14.7252 8.43962 15.6542 9.44017 16.2504C10.4407 16.8467 11.619 17.0724 12.7691 16.888C13.9191 16.7037 14.9678 16.121 15.7319 15.2419C15.9811 15.7598 16.3731 16.1957 16.8617 16.4983C17.3503 16.8009 17.9152 16.9576 18.4899 16.9499C21.6009 16.9499 21.6009 13.4809 21.6009 11.9999C21.598 9.45455 20.5855 7.01429 18.7856 5.21454C16.9856 3.41479 14.5453 2.40255 11.9999 2.3999ZM11.9999 15.1499C11.3769 15.1499 10.7679 14.9652 10.2499 14.619C9.73184 14.2729 9.3281 13.7809 9.08968 13.2054C8.85127 12.6298 8.78889 11.9964 8.91043 11.3854C9.03197 10.7743 9.33198 10.2131 9.77252 9.77252C10.2131 9.33198 10.7743 9.03197 11.3854 8.91043C11.9964 8.78889 12.6298 8.85127 13.2054 9.08968C13.7809 9.3281 14.2729 9.73184 14.619 10.2499C14.9652 10.7679 15.1499 11.3769 15.1499 11.9999C15.1491 12.8351 14.817 13.6358 14.2264 14.2264C13.6358 14.817 12.8351 15.1491 11.9999 15.1499Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1659_20375">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconSendingBg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
        fill="#6FCF97"
      />
      <path
        d="M12.0312 16.8312C10.639 16.8312 9.45455 16.3481 8.47792 15.3818C7.5013 14.4156 7.01299 13.2364 7.01299 11.8442V11.7351L6.45195 12.2961C6.21095 12.5371 5.82022 12.5371 5.57922 12.2961C5.33822 12.0551 5.33822 11.6644 5.57922 11.4234L6.92926 10.0733C7.31978 9.68282 7.95295 9.68282 8.34347 10.0733L9.69351 11.4234C9.9345 11.6644 9.9345 12.0551 9.69351 12.2961C9.45251 12.5371 9.06178 12.5371 8.82078 12.2961L8.25974 11.7351V11.8442C8.25974 12.8831 8.62597 13.7662 9.35844 14.4935C10.0909 15.2208 10.9818 15.5844 12.0312 15.5844C12.3013 15.5844 12.5662 15.5532 12.826 15.4909C12.9369 15.4643 13.0469 15.432 13.1559 15.394C13.4217 15.3014 13.7238 15.3446 13.9229 15.5436C14.2266 15.8474 14.1592 16.3593 13.7578 16.5126C13.6096 16.5692 13.46 16.6182 13.3091 16.6597C12.8935 16.774 12.4675 16.8312 12.0312 16.8312ZM17.0707 13.615C16.6802 14.0055 16.0471 14.0055 15.6565 13.615L14.3065 12.2649C14.0655 12.0239 14.0655 11.6332 14.3065 11.3922C14.5475 11.1512 14.9382 11.1512 15.1792 11.3922L15.7403 11.9532V11.8442C15.7403 10.8052 15.374 9.92208 14.6416 9.19481C13.9091 8.46753 13.0182 8.1039 11.9688 8.1039C11.6987 8.1039 11.4338 8.13507 11.174 8.1974C11.0631 8.22402 10.9531 8.25633 10.8441 8.29432C10.5783 8.38693 10.2762 8.34369 10.0771 8.14467C9.77335 7.84089 9.84081 7.32897 10.2422 7.17572C10.3904 7.11913 10.54 7.07008 10.6909 7.02857C11.1065 6.91429 11.5325 6.85714 11.9688 6.85714C13.361 6.85714 14.5455 7.34026 15.5221 8.30649C16.4987 9.27273 16.987 10.4519 16.987 11.8442V11.9532L17.5481 11.3922C17.789 11.1512 18.1798 11.1512 18.4208 11.3922C18.6618 11.6332 18.6618 12.0239 18.4208 12.2649L17.0707 13.615Z"
        fill="white"
      />
    </svg>
  )
}

export const IconSending = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1822_10989)">
        <path
          d="M12.0545 20.4545C9.61818 20.4545 7.54545 19.6091 5.83636 17.9182C4.12727 16.2273 3.27273 14.1636 3.27273 11.7273V11.5364L2.23438 12.5747C1.84386 12.9652 1.21069 12.9652 0.820166 12.5747L0.707107 12.4617C0.316583 12.0711 0.316582 11.438 0.707107 11.0474L3.65653 8.09802C4.04705 7.70749 4.68022 7.70749 5.07074 8.09802L8.02017 11.0474C8.41069 11.438 8.41069 12.0711 8.02017 12.4617L7.90711 12.5747C7.51658 12.9652 6.88342 12.9652 6.49289 12.5747L5.45455 11.5364V11.7273C5.45455 13.5455 6.09545 15.0909 7.37727 16.3636C8.65909 17.6364 10.2182 18.2727 12.0545 18.2727C12.5273 18.2727 12.9909 18.2182 13.4455 18.1091C13.6728 18.0545 13.8979 17.9863 14.1207 17.9044C14.5248 17.756 14.9871 17.8235 15.2915 18.1278L15.4978 18.3342C15.9624 18.7988 15.8596 19.5808 15.2509 19.8282C14.9345 19.9568 14.6145 20.0656 14.2909 20.1545C13.5636 20.3545 12.8182 20.4545 12.0545 20.4545ZM20.3435 15.3565C19.9529 15.7471 19.3198 15.7471 18.9293 15.3565L15.9798 12.4071C15.5893 12.0166 15.5893 11.3834 15.9798 10.9929L16.0929 10.8798C16.4834 10.4893 17.1166 10.4893 17.5071 10.8798L18.5455 11.9182V11.7273C18.5455 9.90909 17.9045 8.36364 16.6227 7.09091C15.3409 5.81818 13.7818 5.18182 11.9455 5.18182C11.4727 5.18182 11.0091 5.23636 10.5545 5.34545C10.3272 5.40002 10.1021 5.46824 9.87925 5.55011C9.47523 5.69855 9.01289 5.63107 8.70853 5.32671L8.5022 5.12038C8.03761 4.65579 8.14038 3.87375 8.74906 3.62637C9.06547 3.49778 9.38548 3.38899 9.70909 3.3C10.4364 3.1 11.1818 3 11.9455 3C14.3818 3 16.4545 3.84545 18.1636 5.53636C19.8727 7.22727 20.7273 9.29091 20.7273 11.7273V11.9182L21.7656 10.8798C22.1561 10.4893 22.7893 10.4893 23.1798 10.8798L23.2929 10.9929C23.6834 11.3834 23.6834 12.0166 23.2929 12.4071L20.3435 15.3565Z"
          fill="#B3B2AD"
        />
      </g>
      <defs>
        <clipPath id="clip0_1822_10989">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconBell = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1235_14228)">
        <path
          d="M10.656 0.575989C10.32 0.911989 10.08 1.48799 10.08 1.91999C10.08 2.35199 9.55201 2.97599 8.88001 3.26399C7.20001 4.03199 5.76001 6.62399 5.76001 8.87999C5.76001 11.76 4.99201 13.92 3.31201 15.648C0.960014 18.048 1.92001 19.2 6.81601 19.92C8.73601 20.208 9.07201 20.4 9.31201 21.648C9.64801 23.472 11.472 24.384 13.2 23.616C13.968 23.28 14.544 22.512 14.688 21.648C14.928 20.4 15.264 20.208 17.184 19.92C22.08 19.2 23.04 18.048 20.688 15.648C19.008 13.92 18.24 11.76 18.24 8.87999C18.24 6.62399 16.8 4.03199 15.12 3.26399C14.448 2.97599 13.92 2.35199 13.92 1.91999C13.92 0.959988 13.008 -1.14441e-05 12 -1.14441e-05C11.568 -1.14441e-05 10.992 0.239988 10.656 0.575989ZM12.768 1.48799C13.248 2.30399 12.144 3.21599 11.472 2.54399C10.896 1.96799 11.28 0.959988 12 0.959988C12.24 0.959988 12.576 1.19999 12.768 1.48799ZM15.936 5.18399C16.944 6.38399 17.28 7.19999 17.28 8.78399C17.28 11.76 18.096 14.208 19.728 16.08L21.168 17.712L20.064 18.336C19.296 18.768 16.848 18.96 12 18.96C7.15201 18.96 4.70401 18.768 3.93601 18.336L2.83201 17.712L4.27201 16.08C5.90401 14.208 6.72001 11.76 6.72001 8.83199C6.72001 6.71999 8.06401 4.51199 9.64801 3.93599C10.128 3.74399 11.424 3.59999 12.528 3.64799C14.16 3.64799 14.784 3.98399 15.936 5.18399ZM13.824 21.168C13.488 23.52 10.512 23.52 10.176 21.168C10.032 20.256 10.224 20.16 12 20.16C13.776 20.16 13.968 20.256 13.824 21.168Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1235_14228">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconReminderFalse = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.9999 7.92859C3.68447 7.92859 3.42847 8.18459 3.42847 8.50002C3.42847 8.81545 3.68447 9.07145 3.9999 9.07145H11.9999C12.3153 9.07145 12.5713 8.81545 12.5713 8.50002C12.5713 8.18459 12.3153 7.92859 11.9999 7.92859H3.9999Z"
        fill="#EB5757"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.5C3.58171 0.5 0 4.08171 0 8.5C0 12.9171 3.58171 16.5 8 16.5C12.4183 16.5 16 12.9171 16 8.5C16 4.08171 12.4183 0.5 8 0.5ZM1.14286 8.5C1.14286 4.71314 4.21314 1.64286 8 1.64286C11.7869 1.64286 14.8571 4.71314 14.8571 8.5C14.8571 12.2886 11.7869 15.3571 8 15.3571C4.21314 15.3571 1.14286 12.2886 1.14286 8.5Z"
        fill="#EB5757"
      />
    </svg>
  )
}

export const IconReminderTrue = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8439 6.6069C12.0605 6.37718 12.0502 6.01547 11.8211 5.7989C11.5914 5.58232 11.2297 5.5926 11.0131 5.82174L7.11079 9.95145L4.9868 7.70403C4.77023 7.47489 4.40851 7.46461 4.1788 7.68118C3.94965 7.89776 3.93938 8.25947 4.15595 8.48919L6.69536 11.18C6.80336 11.2943 6.95364 11.3572 7.11079 11.3572C7.2685 11.3572 7.41881 11.2943 7.52624 11.18L11.8439 6.6069Z"
        fill="#219653"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.5C3.58171 0.5 0 4.08171 0 8.5C0 12.9171 3.58171 16.5 8 16.5C12.4183 16.5 16 12.9171 16 8.5C16 4.08171 12.4183 0.5 8 0.5ZM1.14286 8.5C1.14286 4.71314 4.21314 1.64286 8 1.64286C11.7869 1.64286 14.8571 4.71314 14.8571 8.5C14.8571 12.2886 11.7869 15.3571 8 15.3571C4.21314 15.3571 1.14286 12.2886 1.14286 8.5Z"
        fill="#219653"
      />
    </svg>
  )
}

export const IconWifi = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33045 3.05369C10.5463 3.05379 12.6775 3.92458 14.2835 5.48608C14.4044 5.60663 14.5977 5.60511 14.7168 5.48267L15.8728 4.28949C15.9331 4.22739 15.9667 4.14327 15.9662 4.05574C15.9657 3.96822 15.9311 3.8845 15.8701 3.82313C11.655 -0.308229 5.00522 -0.308229 0.79012 3.82313C0.729062 3.88446 0.694418 3.96814 0.693855 4.05567C0.693292 4.1432 0.726856 4.22734 0.78712 4.28949L1.94345 5.48267C2.06248 5.6053 2.25593 5.60682 2.37679 5.48608C3.98294 3.92448 6.11434 3.05369 8.33045 3.05369ZM8.33045 6.93563C9.54794 6.93555 10.722 7.39837 11.6245 8.23415C11.7465 8.35276 11.9388 8.35019 12.0578 8.22835L13.2125 7.03517C13.2733 6.97259 13.307 6.88768 13.3061 6.79946C13.3052 6.71123 13.2698 6.62705 13.2078 6.56574C10.4596 3.95126 6.20365 3.95126 3.45545 6.56574C3.39338 6.62705 3.35796 6.71127 3.35714 6.79953C3.35633 6.88778 3.39019 6.97268 3.45112 7.03517L4.60545 8.22835C4.72444 8.35019 4.91672 8.35276 5.03879 8.23415C5.94066 7.39892 7.11377 6.93614 8.33045 6.93563ZM10.5495 9.78324C10.6112 9.72126 10.6452 9.63596 10.6434 9.54749C10.6417 9.45901 10.6043 9.37521 10.5401 9.31585C9.26455 8.21245 7.39636 8.21245 6.12079 9.31585C6.05657 9.37516 6.01912 9.45894 6.01729 9.54741C6.01546 9.63589 6.04941 9.72121 6.11112 9.78324L8.10879 11.8447C8.16734 11.9053 8.24716 11.9394 8.33045 11.9394C8.41374 11.9394 8.49357 11.9053 8.55212 11.8447L10.5495 9.78324Z"
        fill="#060606"
      />
    </svg>
  )
}

export const IconSignal = () => {
  return (
    <svg
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66675 6.8863H2.66675C3.21903 6.8863 3.66675 7.34419 3.66675 7.90902V9.95448C3.66675 10.5193 3.21903 10.9772 2.66675 10.9772H1.66675C1.11446 10.9772 0.666748 10.5193 0.666748 9.95448V7.90902C0.666748 7.34419 1.11446 6.8863 1.66675 6.8863ZM6.33341 4.84084H7.33341C7.8857 4.84084 8.33341 5.29873 8.33341 5.86357V9.95448C8.33341 10.5193 7.8857 10.9772 7.33341 10.9772H6.33341C5.78113 10.9772 5.33341 10.5193 5.33341 9.95448V5.86357C5.33341 5.29873 5.78113 4.84084 6.33341 4.84084ZM11.0001 2.45448H12.0001C12.5524 2.45448 13.0001 2.91237 13.0001 3.47721V9.95448C13.0001 10.5193 12.5524 10.9772 12.0001 10.9772H11.0001C10.4478 10.9772 10.0001 10.5193 10.0001 9.95448V3.47721C10.0001 2.91237 10.4478 2.45448 11.0001 2.45448ZM15.6667 0.0681152H16.6667C17.219 0.0681152 17.6667 0.526006 17.6667 1.09084V9.95448C17.6667 10.5193 17.219 10.9772 16.6667 10.9772H15.6667C15.1145 10.9772 14.6667 10.5193 14.6667 9.95448V1.09084C14.6667 0.526006 15.1145 0.0681152 15.6667 0.0681152Z"
        fill="#060606"
      />
    </svg>
  )
}

export const IconBattery = () => {
  return (
    <svg
      width="25"
      height="11"
      viewBox="0 0 25 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 0C1.11929 0 0 1.11929 0 2.5V8C0 9.38071 1.11929 10.5 2.5 10.5H18.4687H19.5C20.8807 10.5 22 9.38071 22 8V2.5C22 1.11929 20.8807 0 19.5 0H2.5ZM3 1C1.89543 1 1 1.89543 1 3V7.5C1 8.60457 1.89543 9.5 3 9.5H17.4687H19C20.1046 9.5 21 8.60457 21 7.5V3C21 1.89543 20.1046 1 19 1H3Z"
        fill="#ABABAB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 7.37398C23.8626 7.15196 24.5 6.36891 24.5 5.43699C24.5 4.50507 23.8626 3.72202 23 3.5V7.37398Z"
        fill="#ABABAB"
      />
      <rect x="2" y="2" width="18" height="6.5" rx="1" fill="#060606" />
    </svg>
  )
}

export const IconTitle = () => {
  return (
    <svg
      width="70"
      height="15"
      viewBox="0 0 70 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.27131 14.7965V4.79308L9.17682 5.41384L5.68039 14.7965H4.9664L1.43847 5.41384L1.35447 4.79308V14.7965H0V0.203528H0.703486L5.27089 12.171L5.31289 12.7103L5.35489 12.171L9.9118 0.203528H10.6258V14.7965H9.27131Z"
        fill="#0B0C0E"
      />
      <path
        d="M20.1487 11.3976H15.3818L14.3948 14.7965H12.9878L17.3977 0.203528H18.1117L22.5426 14.7965H21.1462L20.1487 11.3976ZM15.7493 10.1459H19.7917L17.8072 3.41927L17.7652 2.87992L17.7232 3.41927L15.7493 10.1459Z"
        fill="#0B0C0E"
      />
      <path
        d="M24.0437 14.7965V14.1757L30.753 1.45522H24.2537V0.203528H32.517V0.834464L25.8076 13.5448H32.517V14.7965H24.0437Z"
        fill="#0B0C0E"
      />
      <path
        d="M43.7934 11.4179C43.7934 11.9132 43.6954 12.3779 43.4994 12.8121C43.3104 13.2463 43.0479 13.6262 42.7119 13.9518C42.3759 14.2775 41.9839 14.5353 41.5359 14.7252C41.0879 14.9084 40.6084 15 40.0974 15H39.0265C38.5155 15 38.0325 14.9084 37.5775 14.7252C37.1295 14.5353 36.7375 14.2775 36.4015 13.9518C36.0655 13.6262 35.7995 13.2463 35.6035 12.8121C35.4145 12.3779 35.32 11.9132 35.32 11.4179V3.58209C35.32 3.08684 35.4145 2.62212 35.6035 2.18792C35.7995 1.75373 36.0655 1.37381 36.4015 1.04817C36.7375 0.722524 37.1295 0.468114 37.5775 0.284939C38.0325 0.0949796 38.5155 0 39.0265 0H40.0974C40.6084 0 41.0879 0.0949796 41.5359 0.284939C41.9839 0.468114 42.3759 0.722524 42.7119 1.04817C43.0479 1.37381 43.3104 1.75373 43.4994 2.18792C43.6954 2.62212 43.7934 3.08684 43.7934 3.58209V11.4179ZM42.4389 3.58209C42.4389 3.25645 42.3759 2.95455 42.2499 2.67639C42.1239 2.39145 41.9524 2.14383 41.7354 1.93351C41.5184 1.7232 41.2629 1.55699 40.9689 1.43487C40.6819 1.31275 40.3704 1.2517 40.0344 1.2517H39.0895C38.7535 1.2517 38.4385 1.31275 38.1445 1.43487C37.8575 1.55699 37.602 1.7232 37.378 1.93351C37.161 2.14383 36.9895 2.39145 36.8635 2.67639C36.7375 2.95455 36.6745 3.25645 36.6745 3.58209V11.4179C36.6745 11.7436 36.7375 12.0488 36.8635 12.3338C36.9895 12.6119 37.161 12.8596 37.378 13.0767C37.602 13.287 37.8575 13.4532 38.1445 13.5753C38.4385 13.6974 38.7535 13.7585 39.0895 13.7585H40.0344C40.3704 13.7585 40.6819 13.6974 40.9689 13.5753C41.2629 13.4532 41.5184 13.287 41.7354 13.0767C41.9524 12.8596 42.1239 12.6119 42.2499 12.3338C42.3759 12.0488 42.4389 11.7436 42.4389 11.4179V3.58209Z"
        fill="#0B0C0E"
      />
      <path
        d="M55.7102 11.4179C55.7102 11.9132 55.6122 12.3779 55.4162 12.8121C55.2272 13.2463 54.9647 13.6262 54.6287 13.9518C54.2927 14.2775 53.9007 14.5353 53.4527 14.7252C53.0048 14.9084 52.5253 15 52.0143 15H50.9433C50.4323 15 49.9493 14.9084 49.4943 14.7252C49.0463 14.5353 48.6543 14.2775 48.3184 13.9518C47.9824 13.6262 47.7164 13.2463 47.5204 12.8121C47.3314 12.3779 47.2369 11.9132 47.2369 11.4179V3.58209C47.2369 3.08684 47.3314 2.62212 47.5204 2.18792C47.7164 1.75373 47.9824 1.37381 48.3184 1.04817C48.6543 0.722524 49.0463 0.468114 49.4943 0.284939C49.9493 0.0949796 50.4323 0 50.9433 0H52.0143C52.5253 0 53.0048 0.0949796 53.4527 0.284939C53.9007 0.468114 54.2927 0.722524 54.6287 1.04817C54.9647 1.37381 55.2272 1.75373 55.4162 2.18792C55.6122 2.62212 55.7102 3.08684 55.7102 3.58209V11.4179ZM54.3557 3.58209C54.3557 3.25645 54.2927 2.95455 54.1667 2.67639C54.0407 2.39145 53.8692 2.14383 53.6522 1.93351C53.4352 1.7232 53.1798 1.55699 52.8858 1.43487C52.5988 1.31275 52.2873 1.2517 51.9513 1.2517H51.0063C50.6703 1.2517 50.3553 1.31275 50.0613 1.43487C49.7743 1.55699 49.5188 1.7232 49.2948 1.93351C49.0778 2.14383 48.9063 2.39145 48.7803 2.67639C48.6543 2.95455 48.5913 3.25645 48.5913 3.58209V11.4179C48.5913 11.7436 48.6543 12.0488 48.7803 12.3338C48.9063 12.6119 49.0778 12.8596 49.2948 13.0767C49.5188 13.287 49.7743 13.4532 50.0613 13.5753C50.3553 13.6974 50.6703 13.7585 51.0063 13.7585H51.9513C52.2873 13.7585 52.5988 13.6974 52.8858 13.5753C53.1798 13.4532 53.4352 13.287 53.6522 13.0767C53.8692 12.8596 54.0407 12.6119 54.1667 12.3338C54.2927 12.0488 54.3557 11.7436 54.3557 11.4179V3.58209Z"
        fill="#0B0C0E"
      />
      <path
        d="M68.6455 14.7965V4.79308L68.551 5.41384L65.0546 14.7965H64.3406L60.8127 5.41384L60.7287 4.79308V14.7965H59.3742V0.203528H60.0777L64.6451 12.171L64.6871 12.7103L64.7291 12.171L69.286 0.203528H70V14.7965H68.6455Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconArrowDownTriangle = () => {
  return (
    <svg
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 5C4.40691 5 4.31382 4.95917 4.24291 4.87792L0.606612 0.71125C0.502614 0.592083 0.471342 0.412917 0.527705 0.257083C0.583704 0.10125 0.716792 9.4763e-09 0.863699 1.58978e-08L8.1363 3.33793e-07C8.28321 3.40215e-07 8.4163 0.10125 8.4723 0.257084C8.52866 0.412917 8.49739 0.592084 8.39339 0.71125L4.75709 4.87792C4.68618 4.95917 4.59309 5 4.5 5Z"
        fill="#0B0C0E"
      />
    </svg>
  )
}

export const IconDatePicker = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#219653" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.83325 16.5171C9.83325 11.8798 11.3793 10.3345 16.0159 10.3345C20.6533 10.3345 22.1993 11.8798 22.1993 16.5171C22.1993 21.1545 20.6533 22.6998 16.0159 22.6998C11.3793 22.6998 9.83325 21.1545 9.83325 16.5171Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0168 14.2159H22.0222"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9524 16.8407H18.9584"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0195 16.8407H16.0255"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0811 16.8407H13.0871"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9524 19.4085H18.9584"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0195 19.4085H16.0255"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0811 19.4085H13.0871"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6888 9.3667V11.5414"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3499 9.3667V11.5414"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconTime = () => {
  return (
    <svg
      width="54"
      height="19"
      viewBox="0 0 54 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1341 14.5745C18.8221 14.5745 20.4187 12.4724 20.4187 8.90552C20.4187 5.40454 18.7195 3.4856 16.1927 3.4856C13.8929 3.4856 12.2669 5.03101 12.2669 7.19165C12.2669 9.22046 13.7317 10.7 15.7459 10.7C16.9837 10.7 17.9871 10.1287 18.4852 9.12524H18.6097C18.5877 11.6082 17.7015 13.0291 16.1561 13.0291C15.2479 13.0291 14.5228 12.531 14.2957 11.7253H12.4134C12.721 13.4465 14.2005 14.5745 16.1341 14.5745ZM16.2 9.24243C14.9695 9.24243 14.1199 8.37817 14.1199 7.13306C14.1199 5.93921 15.0135 5.02368 16.2073 5.02368C17.4012 5.02368 18.2947 5.95386 18.2947 7.16968C18.2947 8.37085 17.4231 9.24243 16.2 9.24243ZM23.4366 7.47729C24.1324 7.47729 24.6085 6.9939 24.6085 6.34204C24.6085 5.69019 24.1324 5.20679 23.4366 5.20679C22.7481 5.20679 22.2647 5.69019 22.2647 6.34204C22.2647 6.9939 22.7481 7.47729 23.4366 7.47729ZM23.4366 12.8533C24.1324 12.8533 24.6085 12.3625 24.6085 11.718C24.6085 11.0662 24.1324 10.5828 23.4366 10.5828C22.7481 10.5828 22.2647 11.0662 22.2647 11.718C22.2647 12.3625 22.7481 12.8533 23.4366 12.8533ZM31.6107 14.3181H33.4198V12.2893H34.848V10.7292H33.4198V3.74927H30.7538C29.3183 5.93188 27.8168 8.36353 26.4472 10.7439V12.2893H31.6107V14.3181ZM28.1977 10.6633C29.2304 8.8689 30.4535 6.91333 31.5375 5.25806H31.64V10.7732H28.1977V10.6633ZM38.8767 14.3181H40.7663V3.74927H38.884L36.1228 5.69019V7.46997L38.7521 5.60962H38.8767V14.3181Z"
        fill="#171717"
      />
    </svg>
  )
}

export const IconFooterIcons = () => {
  return (
    <svg
      width="340"
      height="24"
      viewBox="0 0 340 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12.0054C5 12.2216 5.07447 12.4054 5.23404 12.5568L13.7447 20.7838C13.883 20.9243 14.0638 21 14.266 21C14.6809 21 15 20.6865 15 20.2541C15 20.0486 14.9149 19.8649 14.7979 19.7351L6.79787 12.0054L14.7979 4.27568C14.9149 4.13514 15 3.95135 15 3.74595C15 3.32432 14.6809 3 14.266 3C14.0638 3 13.883 3.07568 13.7447 3.21622L5.23404 11.4541C5.07447 11.6054 5 11.7892 5 12.0054Z"
        fill="#2E7CF6"
      />
      <path
        d="M96 12.0054C96 11.7892 95.9255 11.6054 95.766 11.4541L87.266 3.21622C87.117 3.07568 86.9468 3 86.734 3C86.3298 3 86 3.32432 86 3.74595C86 3.95135 86.0851 4.13514 86.2128 4.27568L94.2021 12.0054L86.2128 19.7351C86.0851 19.8649 86 20.0486 86 20.2541C86 20.6865 86.3298 21 86.734 21C86.9468 21 87.117 20.9243 87.266 20.7838L95.766 12.5568C95.9255 12.4054 96 12.2216 96 12.0054Z"
        fill="#2E7CF6"
      />
      <path
        d="M170.005 15.6906C170.346 15.6906 170.636 15.3993 170.636 15.0432V3.42086L170.594 1.85611L171.515 2.84892L173.272 4.75899C173.386 4.88849 173.551 4.95324 173.706 4.95324C174.027 4.95324 174.285 4.70504 174.285 4.3705C174.285 4.18705 174.213 4.05755 174.099 3.92806L170.46 0.215827C170.305 0.0539568 170.171 0 170.005 0C169.84 0 169.705 0.0539568 169.55 0.215827L165.911 3.92806C165.787 4.05755 165.715 4.18705 165.715 4.3705C165.715 4.70504 165.963 4.95324 166.294 4.95324C166.449 4.95324 166.624 4.88849 166.738 4.75899L168.496 2.84892L169.416 1.85611L169.374 3.42086V15.0432C169.374 15.3993 169.664 15.6906 170.005 15.6906ZM164.05 24H175.95C177.966 24 179 22.9209 179 20.8489V9.82014C179 7.73741 177.966 6.65827 175.95 6.65827H173.003V7.9964H175.919C177.067 7.9964 177.718 8.64388 177.718 9.88489V20.7734C177.718 22.0252 177.067 22.6619 175.919 22.6619H164.071C162.913 22.6619 162.282 22.0252 162.282 20.7734V9.88489C162.282 8.64388 162.913 7.9964 164.071 7.9964H167.007V6.65827H164.05C162.034 6.65827 161 7.72662 161 9.82014V20.8489C161 22.9317 162.034 24 164.05 24Z"
        fill="#2E7CF6"
      />
      <path
        d="M249 4.02343C248.335 3.11821 246.053 2 243.36 2C240.136 2 237.432 3.58679 237 4.88605V21.0948C237 21.7338 237.432 22 237.931 22C238.33 22 238.562 21.8829 238.795 21.7018C239.537 21.0202 240.934 20.1896 243.36 20.1896C245.831 20.1896 247.371 21.0309 247.981 21.6486C248.213 21.8403 248.49 22 249 22C249.499 22 249.776 21.819 250.019 21.6486C250.662 21.0522 252.169 20.1896 254.64 20.1896C257.066 20.1896 258.496 20.9989 259.205 21.7018C259.438 21.8829 259.67 22 260.069 22C260.568 22 261 21.7338 261 21.0948V4.88605C260.568 3.58679 257.864 2 254.64 2C251.947 2 249.665 3.11821 249 4.02343ZM238.463 5.31203C238.629 4.64111 240.59 3.3312 243.36 3.3312C246.141 3.3312 248.114 4.65176 248.269 5.31203V20.3067C247.15 19.3908 245.343 18.8797 243.36 18.8797C241.366 18.8797 239.56 19.4015 238.463 20.328V5.31203ZM259.537 5.31203V20.328C258.429 19.4015 256.634 18.8797 254.64 18.8797C252.657 18.8797 250.85 19.3908 249.731 20.3067V5.31203C249.886 4.65176 251.859 3.3312 254.64 3.3312C257.41 3.3312 259.36 4.64111 259.537 5.31203Z"
        fill="#2E7CF6"
      />
      <path
        d="M320.122 18.2749H322.132V19.8246C322.132 21.9271 323.18 23 325.254 23H335.878C337.942 23 339 21.9163 339 19.8246V8.88966C339 6.79803 337.942 5.72512 335.878 5.72512H333.868V4.16453C333.868 2.08374 332.81 1 330.746 1H320.122C318.048 1 317 2.06207 317 4.16453V15.1103C317 17.202 318.048 18.2749 320.122 18.2749ZM320.143 16.931C318.958 16.931 318.312 16.2916 318.312 15.0345V4.24039C318.312 2.98325 318.958 2.34384 320.143 2.34384H330.725C331.889 2.34384 332.556 2.98325 332.556 4.24039V5.72512H325.254C323.18 5.72512 322.132 6.78719 322.132 8.88966V16.931H320.143ZM325.275 21.6562C324.09 21.6562 323.444 21.0059 323.444 19.7596V8.95468C323.444 7.70837 324.09 7.05813 325.275 7.05813H335.857C337.021 7.05813 337.688 7.70837 337.688 8.95468V19.7596C337.688 21.0059 337.021 21.6562 335.857 21.6562H325.275Z"
        fill="#2E7CF6"
      />
    </svg>
  )
}

export const IconLock = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.29341 15H11.7066C12.5756 15 13 14.5736 13 13.6407V8.74987C13 7.9103 12.6497 7.47719 11.9289 7.4039V5.72476C11.9289 3.21271 10.265 2 8.5 2C6.73503 2 5.07111 3.21271 5.07111 5.72476V7.43721C4.41093 7.53716 4 7.96361 4 8.74987V13.6407C4 14.5736 4.4244 15 5.29341 15ZM6.15569 5.58483C6.15569 3.91235 7.24027 3.02614 8.5 3.02614C9.75973 3.02614 10.8443 3.91235 10.8443 5.58483V7.39723L6.15569 7.4039V5.58483Z"
        fill="#676769"
      />
    </svg>
  )
}

export const IconRefresh = () => {
  return (
    <svg
      className="phone-refresh"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6695 10.8161C11.8959 10.8161 12.0679 10.7455 12.1947 10.6131L15.9253 6.95959C16.0883 6.80957 16.1517 6.63307 16.1517 6.4301C16.1517 6.23595 16.0702 6.0418 15.9253 5.9006L12.1947 2.2118C12.0679 2.0706 11.8868 2 11.6695 2C11.262 2 10.9542 2.3177 10.9542 2.72364C10.9542 2.90896 11.0266 3.08546 11.1534 3.22666L13.571 5.53878C13.0549 5.45053 12.5297 5.39758 12.0045 5.39758C7.56763 5.39758 4 8.86577 4 13.19C4 17.523 7.56763 21 12.0045 21C16.4414 21 20 17.523 20 13.19C20 12.7664 19.6921 12.4575 19.2484 12.4575C18.8229 12.4575 18.5422 12.7664 18.5422 13.19C18.5422 16.7376 15.6355 19.5792 12.0045 19.5792C8.37351 19.5792 5.45784 16.7376 5.45784 13.19C5.45784 9.65118 8.37351 6.81839 12.0045 6.81839C12.6927 6.81839 13.3265 6.87134 13.8698 6.98607L11.1624 9.60706C11.0266 9.74826 10.9542 9.92476 10.9542 10.1101C10.9542 10.516 11.262 10.8161 11.6695 10.8161Z"
        fill="black"
      />
    </svg>
  )
}

export const IconTextSize = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.52385 17.9619C3.78577 17.9619 3.93711 17.8477 4.03605 17.5867L4.77526 15.6397H8.09879L8.84382 17.5867C8.94276 17.8477 9.0941 17.9619 9.35602 17.9619C9.65869 17.9619 9.87987 17.7825 9.87987 17.5323C9.87987 17.4616 9.86241 17.38 9.81585 17.2604L7.1093 10.4296C6.98125 10.1088 6.77171 9.96193 6.45158 9.96193C6.10817 9.96193 5.89281 10.1142 5.76475 10.4351L3.06403 17.2604C3.01746 17.38 3 17.4616 3 17.5323C3 17.7825 3.22118 17.9619 3.52385 17.9619ZM5.07793 14.8076L6.42247 11.2291H6.4574L7.80194 14.8076H5.07793Z"
        fill="#202124"
      />
      <path
        d="M11.466 18C11.8589 18 12.0859 17.8287 12.2343 17.4371L13.3431 14.5167H18.3284L19.4459 17.4371C19.5943 17.8287 19.8213 18 20.2142 18C20.6682 18 21 17.7308 21 17.3555C21 17.2495 20.9738 17.1271 20.904 16.9477L16.8441 6.70156C16.6521 6.22026 16.3378 6 15.8576 6C15.3424 6 15.0194 6.22842 14.8273 6.70972L10.7762 16.9477C10.7064 17.1271 10.6802 17.2495 10.6802 17.3555C10.6802 17.7308 11.012 18 11.466 18ZM13.7971 13.2685L15.8139 7.90075H15.8663L17.8831 13.2685H13.7971Z"
        fill="#202124"
      />
    </svg>
  )
}

export const IconChevronUp = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L11.2929 8.29289C11.6834 7.90237 12.3166 7.90237 12.7071 8.29289L18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071L12 10.4142L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071Z"
        fill="black"
      />
    </svg>
  )
}

export const IconSortArrows = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00033 8.75C8.20119 8.75 8.38252 8.87013 8.46079 9.05513C8.53906 9.24007 8.49913 9.45387 8.35926 9.59807L5.69262 12.3481C5.59845 12.4452 5.46895 12.5 5.33367 12.5C5.1984 12.5 5.06889 12.4452 4.97472 12.3481L2.30805 9.59807C2.16824 9.45387 2.12827 9.24007 2.20655 9.05513C2.28483 8.87013 2.46617 8.75 2.667 8.75H4.83367V4C4.83367 3.72386 5.05752 3.5 5.33367 3.5C5.60981 3.5 5.83367 3.72386 5.83367 4V8.75H8.00033ZM13.3337 7.25C13.5345 7.25 13.7159 7.12987 13.7941 6.94487C13.8724 6.75993 13.8325 6.54611 13.6926 6.40193L11.0259 3.65193C10.9318 3.55481 10.8023 3.5 10.667 3.5C10.5317 3.5 10.4023 3.55481 10.3081 3.65193L7.64139 6.40193C7.50159 6.54611 7.46159 6.75993 7.53986 6.94487C7.61819 7.12987 7.79953 7.25 8.00033 7.25H10.167V12C10.167 12.2761 10.3909 12.5 10.667 12.5C10.9431 12.5 11.167 12.2761 11.167 12V7.25H13.3337Z"
        fill="#363C3E"
      />
    </svg>
  )
}

export const IconTrash = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.78716 3.87965C6.78716 3.31078 7.24833 2.84961 7.81721 2.84961C8.38608 2.84961 8.84725 3.31078 8.84725 3.87965H12.4524C12.7368 3.87965 12.9674 4.11024 12.9674 4.39467C12.9674 4.67911 12.7368 4.9097 12.4524 4.9097H11.9374V11.09C11.9374 12.2277 11.015 13.15 9.87729 13.15H5.75712C4.61937 13.15 3.69704 12.2277 3.69704 11.09V4.9097H3.18201C2.89758 4.9097 2.66699 4.67911 2.66699 4.39467C2.66699 4.11024 2.89758 3.87965 3.18201 3.87965H6.78716ZM4.72708 4.9097V11.09C4.72708 11.6588 5.18824 12.12 5.75712 12.12H9.87729C10.4462 12.12 10.9073 11.6588 10.9073 11.09V4.9097H4.72708ZM8.33223 7.4848C8.33223 7.20036 8.56281 6.96978 8.84725 6.96978C9.13169 6.96978 9.36227 7.20036 9.36227 7.4848V9.54489C9.36227 9.82933 9.13169 10.0599 8.84725 10.0599C8.56281 10.0599 8.33223 9.82933 8.33223 9.54489V7.4848ZM6.27214 7.4848C6.27214 7.20036 6.50273 6.96978 6.78716 6.96978C7.0716 6.96978 7.30219 7.20036 7.30219 7.4848V9.54489C7.30219 9.82933 7.0716 10.0599 6.78716 10.0599C6.50273 10.0599 6.27214 9.82933 6.27214 9.54489V7.4848Z"
        fill="#363C3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.06331 4.14632H3.18201C3.0591 4.14632 2.94314 4.24865 2.94314 4.39467C2.94314 4.54069 3.0591 4.64303 3.18201 4.64303H3.97318V11.09C3.97318 12.0893 4.78089 12.8834 5.75712 12.8834H9.87729C10.8535 12.8834 11.6612 12.0893 11.6612 11.09V4.64303H12.4524C12.5753 4.64303 12.6913 4.54069 12.6913 4.39467C12.6913 4.24865 12.5753 4.14632 12.4524 4.14632H8.5711V3.87965C8.5711 3.44919 8.22456 3.11628 7.81721 3.11628C7.40986 3.11628 7.06331 3.44919 7.06331 3.87965V4.14632ZM4.45093 4.64303H11.1835V11.09C11.1835 11.7972 10.6077 12.3867 9.87729 12.3867H5.75712C5.02672 12.3867 4.45093 11.7972 4.45093 11.09V4.64303ZM8.84725 3.87965C8.84725 3.31078 8.38608 2.84961 7.81721 2.84961C7.24833 2.84961 6.78716 3.31078 6.78716 3.87965H3.18201C2.89758 3.87965 2.66699 4.11024 2.66699 4.39467C2.66699 4.67911 2.89758 4.9097 3.18201 4.9097H3.69704V11.09C3.69704 12.2277 4.61937 13.15 5.75712 13.15H9.87729C11.015 13.15 11.9374 12.2277 11.9374 11.09V4.9097H12.4524C12.7368 4.9097 12.9674 4.67911 12.9674 4.39467C12.9674 4.11024 12.7368 3.87965 12.4524 3.87965H8.84725ZM4.72708 11.09C4.72708 11.6588 5.18824 12.12 5.75712 12.12H9.87729C10.4462 12.12 10.9073 11.6588 10.9073 11.09V4.9097H4.72708V11.09ZM8.84725 7.23645C8.72434 7.23645 8.60838 7.33878 8.60838 7.4848V9.54489C8.60838 9.69091 8.72434 9.79324 8.84725 9.79324C8.97016 9.79324 9.08612 9.69091 9.08612 9.54489V7.4848C9.08612 7.33878 8.97016 7.23645 8.84725 7.23645ZM6.78716 7.23645C6.66425 7.23645 6.54829 7.33878 6.54829 7.4848V9.54489C6.54829 9.69091 6.66425 9.79324 6.78716 9.79324C6.91008 9.79324 7.02604 9.69091 7.02604 9.54489V7.4848C7.02604 7.33878 6.91008 7.23645 6.78716 7.23645ZM8.84725 6.96978C8.56281 6.96978 8.33223 7.20036 8.33223 7.4848V9.54489C8.33223 9.82933 8.56281 10.0599 8.84725 10.0599C9.13169 10.0599 9.36227 9.82933 9.36227 9.54489V7.4848C9.36227 7.20036 9.13169 6.96978 8.84725 6.96978ZM6.78716 6.96978C6.50273 6.96978 6.27214 7.20036 6.27214 7.4848V9.54489C6.27214 9.82933 6.50273 10.0599 6.78716 10.0599C7.0716 10.0599 7.30219 9.82933 7.30219 9.54489V7.4848C7.30219 7.20036 7.0716 6.96978 6.78716 6.96978Z"
        fill="#363C3E"
      />
    </svg>
  )
}

export const IconCheckSmall = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3337 4L6.00033 11.3333L2.66699 8"
        stroke="#0B0C0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconEdit = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.204 4.51327L4.88697 14.8304C3.70435 16.013 3.70434 17.9304 4.88697 19.113C6.0696 20.2957 7.98702 20.2957 9.16965 19.113L19.4867 8.79595C20.1711 8.11159 20.1711 7.00201 19.4867 6.31765L17.6824 4.51327C16.998 3.82891 15.8884 3.82891 15.204 4.51327ZM13.3778 8.59114L16.3299 5.6391C16.3925 5.57651 16.4939 5.57651 16.5565 5.6391L18.3609 7.44347C18.4235 7.50606 18.4235 7.60754 18.3609 7.67012L15.4089 10.6222L13.3778 8.59114ZM12.252 9.71697L6.0128 15.9562C5.45194 16.517 5.45194 17.4264 6.01279 17.9872C6.57365 18.5481 7.48297 18.5481 8.04382 17.9872L14.283 11.748L12.252 9.71697Z"
        fill="#363C3E"
      />
    </svg>
  )
}

//events-page

export const IconLink = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2007_11594)">
        <path
          d="M6.54547 8.72707C6.8578 9.14462 7.25628 9.49011 7.71387 9.74012C8.17147 9.99012 8.67748 10.1388 9.19758 10.176C9.71768 10.2133 10.2397 10.1382 10.7283 9.956C11.2168 9.77376 11.6605 9.48858 12.0291 9.1198L14.2109 6.93798C14.8733 6.25215 15.2398 5.3336 15.2316 4.38016C15.2233 3.42671 14.8408 2.51467 14.1666 1.84046C13.4924 1.16625 12.5804 0.783813 11.6269 0.775528C10.6735 0.767243 9.75493 1.13377 9.06911 1.79616L7.8182 3.0398"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.45457 7.27271C9.14224 6.85517 8.74376 6.50967 8.28617 6.25967C7.82857 6.00966 7.32256 5.86099 6.80246 5.82374C6.28235 5.78649 5.76032 5.86154 5.27177 6.04378C4.78322 6.22603 4.33957 6.51121 3.97093 6.87999L1.78911 9.0618C1.12672 9.74763 0.760193 10.6662 0.768479 11.6196C0.776764 12.5731 1.1592 13.4851 1.83341 14.1593C2.50762 14.8335 3.41966 15.216 4.37311 15.2243C5.32655 15.2325 6.2451 14.866 6.93093 14.2036L8.17457 12.96"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2007_11594">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Check = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      style={{
        marginBottom: "5px",
        width: "20px",
        height: "20px",
        // backgroundColor: "green",
      }}
      fill="green"
      className="bi bi-check-circle-fill"
      viewBox="0 0 16 16"
    >
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
  )
}

export const Dollar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-currency-dollar"
      viewBox="0 0 16 16"
      style={{
        marginBottom: "5px",
        width: "20px",
        height: "20px",
        backgroundColor: "#e2e4ea",
        color: "white",
        borderRadius: "50%",
      }}
    >
      <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73z" />
    </svg>
  )
}
